const hr = {
  'common.loading': 'Učitavanje…',
  'common.save': 'Spremi',
  'common.saving': 'Spremanje…',
  'common.cancel': 'Odustani',
  'common.delete': 'Izbriši',
  'common.search': 'Pretraži',
  'common.sortBy': 'Sortiraj prema',
  'common.never': 'Nikad',
  'common.justNow': 'Upravo sada',
  'common.accessDenied': 'Pristup odbijen',
  'common.backToLogin': 'Natrag na prijavu',
  'common.markAsRead': 'Označi kao pročitano',
  'common.user': 'Korisnik',
  'shell.supportDesk': 'Centar za podršku',
  'shell.searchPlaceholder': 'Pretraži zahtjeve, kontakte, članke…',
  'shell.newTicket': 'Novi zahtjev',
  'shell.notifications': 'Obavijesti',
  'shell.notificationPreferences': 'Postavke obavijesti',
  'shell.settings': 'Postavke',
  'shell.signOut': 'Odjava',
  'shell.expandNavigation': 'Proširi navigaciju',
  'shell.collapseNavigation': 'Skupi navigaciju',
  'shell.adminNavigation': 'Administratorska navigacija',
  'shell.caughtUp': 'Sve je pregledano',
  'shell.viewAllNotifications': 'Prikaži sve obavijesti',
  'nav.dashboard': 'Nadzorna ploča',
  'nav.tickets': 'Zahtjevi',
  'nav.contacts': 'Kontakti',
  'nav.companies': 'Tvrtke',
  'nav.reports': 'Izvješća',
  'nav.settings': 'Postavke',
  'nav.agents': 'Agenti',
  'nav.groups': 'Grupe',
  'nav.roles': 'Uloge',
  'nav.tags': 'Oznake',
  'nav.ticketFields': 'Polja zahtjeva',
  'nav.ticketForms': 'Obrasci zahtjeva',
  'nav.businessHours': 'Radno vrijeme',
  'nav.slaPolicies': 'SLA pravila',
  'nav.automations': 'Automatizacije',
  'nav.email': 'E-pošta',
  'nav.notificationTemplates': 'Predlošci obavijesti',
  'nav.apiKeys': 'API ključevi',
  'nav.cannedResponses': 'Spremljeni odgovori',
  'nav.knowledgeBase': 'Baza znanja',
  'auth.signInTitle': 'SDPL centar za podršku',
  'auth.signInSubtitle': 'Prijavite se na svoj račun',
  'auth.emailAddress': 'Adresa e-pošte',
  'auth.password': 'Lozinka',
  'auth.signingIn': 'Prijava…',
  'auth.signIn': 'Prijava',
  'auth.forgotPassword': 'Zaboravili ste lozinku?',
  'auth.twoFactor': 'Dvofaktorska autentifikacija',
  'auth.verificationCode': 'Verifikacijski kod',
  'auth.verify': 'Potvrdi',
  'auth.backToLogin': 'Natrag na prijavu',
  'agents.title': 'Agenti',
  'agents.new': 'Novi agent',
  'agents.supportAgents': 'Agenti podrške',
  'agents.collaborators': 'Suradnici',
  'agents.deactivated': 'Deaktivirani',
  'agents.searchPlaceholder': 'Pretraži po imenu ili e-pošti',
  'agents.noSearchResults': 'Nijedan agent ne odgovara pretraživanju',
  'agents.noAgentsView': 'Nema agenata u ovom prikazu',
  'agents.edit': 'Uredi',
  'agents.deactivate': 'Deaktiviraj',
  'agents.reactivate': 'Ponovno aktiviraj',
  'agents.saved': 'Agent je spremljen.',
  'agents.firstName': 'Ime',
  'agents.lastName': 'Prezime',
  'agents.email': 'E-pošta',
  'agents.phone': 'Telefon',
  'agents.timezone': 'Vremenska zona',
  'agents.selectTimezone': 'Odaberite vremensku zonu',
  'agents.language': 'Jezik',
  'agents.selectLanguage': 'Odaberite jezik',
  'agents.emailSignature': 'Potpis e-pošte',
  'agents.roleRequired': 'Uloga',
  'agents.selectRole': 'Odaberite ulogu',
  'agents.status': 'Status',
  'agents.groupsTitle': 'Grupe',
  'agents.manageGroups': 'Upravljanje grupama',
  'agents.notInGroup': 'Još nije u grupi',
  'dashboard.title': 'Nadzorna ploča',
  'dashboard.description': 'Trenutno opterećenje podrške i stanje usluge.',
  'dashboard.allGroups': 'Sve dostupne grupe',
  'dashboard.unresolved': 'Neriješeni',
  'dashboard.overdue': 'Prekoračeni',
  'dashboard.dueToday': 'Dospijevaju danas',
  'dashboard.open': 'Otvoreni',
  'dashboard.onHold': 'Na čekanju',
  'dashboard.unassigned': 'Nedodijeljeni',
  'dashboard.trends': 'Današnji trendovi',
  'dashboard.today': 'Danas',
  'dashboard.yesterday': 'Jučer',
  'notifications.title': 'Obavijesti',
  'notifications.description': 'Vaša potpuna povijest obavijesti.',
  'notifications.markAllRead': 'Označi sve kao pročitano',
  'notifications.filter': 'Filtar',
  'notifications.allTypes': 'Sve vrste',
  'notifications.none': 'Još nema obavijesti',
  'notifications.assigned': 'Dodijeljeno',
  'notifications.reply': 'Odgovor',
  'notifications.note': 'Bilješka',
  'notifications.slaWarning': 'SLA upozorenje',
  'notifications.slaBreach': 'SLA prekoračen',
  'notifications.slaEscalation': 'SLA eskalacija',
  'notifications.mention': 'Spominjanje',
  'preferences.title': 'Postavke obavijesti',
  'preferences.description': 'Obavijesti u aplikaciji uvijek su uključene. Odaberite koje će slati i e-poštu.',
  'preferences.emailDigest': 'Sažetak e-pošte',
  'preferences.dailySummary': 'Primajte jedan dnevni sažetak umjesto e-pošte za svaki događaj.',
  'preferences.digestOff': 'Isključeno — e-pošta za svaki događaj',
  'preferences.digestDaily': 'Dnevni sažetak',
  'preferences.emailNotifications': 'Obavijesti e-poštom',
  'activities.button': 'Nedavne aktivnosti',
  'activities.title': 'Nedavne aktivnosti',
  'activities.loadError': 'Nedavne aktivnosti nije moguće učitati.',
  'activities.systemActor': 'Sustav',
  'activities.noneTitle': 'Još nema nedavnih aktivnosti',
  'activities.noneDescription': 'Ažuriranja karti od vas i vaše grupe ovdje će se prikazati kako se događaju.',
  'tickets.title': 'Karte',
  'tickets.description': 'Sve karte kojima imate pristup, filtrirane i sortirane kako vama odgovara.',
  'tickets.dueDateTabs': 'Rok karte',
  'tickets.tabAll': 'Sve karte',
  'tickets.tabDueToday': 'Rok danas',
  'tickets.tabOverdue': 'Zakasnjelo',
  'tickets.tabDueTomorrow': 'Rok sutra',
  'tickets.searchPlaceholder': 'Pretraži karte…',
  'tickets.searchAria': 'Pretraži karte',
  'tickets.filters': 'Filtri',
  'tickets.filtersWithCount': 'Filtri ({count})',
  'tickets.sortAria': 'Sortiraj karte prema',
  'tickets.sortTrigger': 'Sortiraj: {label}',
  'tickets.sortDateCreated': 'Datum stvaranja',
  'tickets.sortDateUpdated': 'Datum ažuriranja',
  'tickets.sortPriority': 'Prioritet',
  'tickets.sortStatus': 'Status',
  'tickets.sortDueDate': 'Rok',
  'tickets.sortAscending': 'Sortiraj uzlazno',
  'tickets.sortDescending': 'Sortiraj silazno',
  'tickets.ascending': 'Uzlazno',
  'tickets.descending': 'Silazno',
  'tickets.layoutAria': 'Raspored redaka',
  'tickets.layoutTrigger': 'Raspored: {label}',
  'tickets.layoutCard': 'Kartica',
  'tickets.layoutInbox': 'Pristigla pošta',
  'tickets.layoutTable': 'Tablica',
  'tickets.export': 'Izvoz',
  'tickets.exportSelected': 'Izvezi odabrano',
  'tickets.selectedCount': 'Odabrano: {count}',
  'tickets.assignAgent': 'Dodijeli agenta',
  'tickets.closeAll': 'Zatvori sve',
  'tickets.clearSelection': 'Poništi odabir',
  'tickets.selectAgentPlaceholder': 'Odaberite agenta...',
  'tickets.assignTo': 'Dodijeli osobi',
  'tickets.assign': 'Dodijeli',
  'tickets.loadFailed': 'Karte nije moguće učitati. Pokušajte ponovo.',
  'tickets.bulkCloseFailed': 'Odabrane karte nije moguće zatvoriti. Pokušajte ponovo.',
  'tickets.bulkAssignFailed': 'Odabrane karte nije moguće dodijeliti. Pokušajte ponovo.',
  'tickets.noFilterMatchTitle': 'Nijedna karta ne odgovara ovim filtrima',
  'tickets.noFilterMatchDescription': 'Pokušajte ukloniti filtar, proširiti raspon datuma ili pretražiti drugi izraz.',
  'tickets.clearFilters': 'Poništi filtre',
  'tickets.queueClearTitle': 'Ovaj red je prazan',
  'tickets.queueClearDescription': 'Nove karte ovdje će se prikazati kada klijent pošalje e-poštu, koristi portal ili agent stvori kartu.',
  'tickets.newTicket': 'Nova karta',
  'tickets.selectAllAria': 'Odaberi sve karte',
  'tickets.selectTicketAria': 'Odaberi kartu br. {number}',
  'tickets.columnContact': 'Kontakt',
  'tickets.columnSubject': 'Predmet',
  'tickets.columnState': 'Stanje',
  'tickets.columnGroup': 'Grupa',
  'tickets.columnAgent': 'Agent',
  'tickets.columnPriority': 'Prioritet',
  'tickets.noGroup': 'Nema grupe',
  'tickets.unassigned': 'Nedodijeljeno',
  'tickets.createdRelative': 'Stvoreno {when}',
  'tickets.unassignedOnly': 'Samo nedodijeljeno',
  'tickets.unknownRequester': 'Nepoznati podnositelj',
  'tickets.overdueBy': 'Zakasnjelo za {duration}',
  'tickets.dueIn': 'Rok za {duration}',
  'tickets.filtersDrawerTitle': 'Filtri',
  'tickets.filtersSearchPlaceholder': 'Pretraži polja',
  'tickets.filtersSearchAria': 'Pretraži polja filtra',
  'tickets.filtersClearAll': 'Poništi sve',
  'tickets.filtersApply': 'Primijeni',
  'tickets.filterAgents': 'Agenti',
  'tickets.filterAnyAgent': 'Bilo koji agent',
  'tickets.filterGroups': 'Grupe',
  'tickets.filterAnyGroup': 'Bilo koja grupa',
  'tickets.filterStatus': 'Status',
  'tickets.filterAnyStatus': 'Bilo koji status',
  'tickets.filterPriority': 'Prioritet',
  'tickets.filterAnyPriority': 'Bilo koji prioritet',
  'tickets.filterSource': 'Izvor',
  'tickets.filterAnySource': 'Bilo koji izvor',
  'tickets.filterTicketType': 'Vrsta karte',
  'tickets.filterAnyType': 'Bilo koja vrsta',
  'tickets.filterTags': 'Oznake',
  'tickets.filterAnyTag': 'Bilo koja oznaka',
  'tickets.filterCompanies': 'Tvrtke',
  'tickets.filterAnyCompany': 'Bilo koja tvrtka',
  'tickets.filterCreated': 'Stvoreno',
  'tickets.filterResolvedAt': 'Riješeno',
  'tickets.filterClosedAt': 'Zatvoreno',
  'tickets.filterDateFrom': '{label} od',
  'tickets.filterDateTo': '{label} do',
  'tickets.filterDateTo2': 'do',
  'tickets.filterAny': 'Bilo koji',
  'tickets.chipFieldStatus': 'Status',
  'tickets.chipFieldPriority': 'Prioritet',
  'tickets.chipFieldGroup': 'Grupa',
  'tickets.chipFieldAssignee': 'Nositelj',
  'tickets.chipValueGroup': 'Grupa',
  'tickets.chipValueUnassigned': 'Nedodijeljeno',
  'common.clearSearch': 'Očisti pretragu',
  'common.name': 'Ime',
  'common.role': 'Uloga',
  'common.groups': 'Grupe',
  'common.tickets': 'Karte',
  'common.lastSeen': 'Zadnji put viđen',
  'common.actions': 'Radnje',
  'common.minutesAgo': 'prije {count} min',
  'common.hoursAgo': 'prije {count} h',
  'common.daysAgo': 'prije {count} d',
  'common.noPagePermission': 'Nemate dopuštenje za pristup ovoj stranici.',
  'common.roleNoPermission': 'Vaša uloga nema dopuštenje za pristup ovoj stranici.',
  'common.requestFailed': 'Zahtjev nije uspio. Pokušajte ponovo.',
  'common.unexpectedError': 'Došlo je do neočekivane pogreške',
  'shell.skipToMain': 'Preskoči na glavni sadržaj',
  'shell.homeLabel': 'Početna stranica Suzuki Support Desk',
  'shell.userMenu': 'Korisnički izbornik',
  'shell.unread': '{count} nepročitano',
  'shell.notificationDescription': 'Nova dodjeljivanja, odgovori i SLA upozorenja prikazuju se ovdje.',
  'auth.enterAuthenticatorCode': 'Unesite 6-znamenkasti kod iz aplikacije za autentifikaciju',
  'auth.verifying': 'Provjera…',
  'auth.setupAuthenticator': 'Postavi autentifikator',
  'auth.scanAuthenticator': 'Skenirajte ovaj kod aplikacijom za autentifikaciju (Google Authenticator, Authy itd.)',
  'auth.authenticatorSetupQr': 'QR kod za postavljanje autentifikatora',
  'auth.verificationCodeFromAuthenticator': 'Verifikacijski kod iz autentifikatora',
  'auth.verifyAndComplete': 'Potvrdi i završi postavljanje',
  'auth.loadingSetup': 'Učitavanje postavljanja…',
  'auth.setNewPassword': 'Postavi novu lozinku',
  'auth.temporaryPasswordExpired': 'Vaša privremena lozinka je istekla. Postavite novu lozinku.',
  'auth.newPassword': 'Nova lozinka',
  'auth.confirmPassword': 'Potvrdite lozinku',
  'auth.settingPassword': 'Postavljanje lozinke…',
  'auth.setPassword': 'Postavi lozinku',
  'auth.passwordRequirements': 'Potrebno je najmanje 8 znakova, veliko i malo slovo, broj i simbol',
  'auth.tooManyAttempts': 'Previše pokušaja prijave. Pokušajte ponovo kasnije.',
  'auth.invalidCredentials': 'Neispravna e-pošta ili lozinka',
  'auth.passwordsDoNotMatch': 'Lozinke se ne podudaraju',
  'auth.passwordMinimum': 'Lozinka mora imati najmanje {count} znakova',
  'auth.resetTitle': 'Resetirajte lozinku',
  'auth.resetSubtitle': 'Unesite svoju e-poštu i poslat ćemo vam poveznicu za resetiranje',
  'auth.checkEmail': 'Provjerite e-poštu za poveznicu za resetiranje',
  'auth.checkCode': 'Provjerite e-poštu za verifikacijski kod, a zatim nastavite ispod.',
  'auth.continueToReset': 'Nastavi na resetiranje lozinke',
  'auth.sendResetLink': 'Pošalji poveznicu za resetiranje',
  'auth.sending': 'Slanje…',
  'auth.resetSuccess': 'Vaša lozinka je uspješno resetirana.',
  'auth.goToLogin': 'Idi na prijavu',
  'auth.missingResetToken': 'Nedostaje token za resetiranje. Koristite poveznicu iz e-pošte.',
  'auth.enterCodeFromEmail': 'Unesite verifikacijski kod poslan na vašu e-poštu',
  'auth.codeFromEmail': 'Unesi kod iz e-pošte',
  'auth.emailRequired': 'E-pošta je obavezna',
  'auth.codeRequired': 'Verifikacijski kod je obavezan',
  'auth.missingToken': 'Nedostaje token za resetiranje',
  'auth.failedReset': 'Resetiranje lozinke nije uspjelo.',
  'auth.resetting': 'Resetiranje…',
  'auth.resetPassword': 'Resetiraj lozinku',
  'auth.looksGood': 'Izgleda dobro',
  'auth.needCharacters': 'Potrebno je najmanje {count} znakova',
  'auth.passwordFormat': 'Potrebno je najmanje {count} znakova, veliko i malo slovo, broj i simbol',
  'agents.description': 'Ljudi koji rade na kartama. Dodijelite ulogu za kontrolu što mogu učiniti, i grupe za kontrolu što vide.',
  'agents.searchAria': 'Pretraži agente',
  'agents.countOne': '{count} agent',
  'agents.countMany': '{count} agenata',
  'agents.ticketOne': '{count} karta',
  'agents.ticketMany': '{count} karata',
  'agents.noGroups': 'Nema grupa',
  'agents.lifecycle': 'Životni ciklus agenta',
  'agents.tryDifferent': 'Pokušajte s drugim imenom ili e-poštom.',
  'agents.useNewAgent': 'Koristite Novi agent za dodavanje osobe ili promijenite karticu za prikaz drugih agenata.',
  'agents.agent': 'Agent',
  'agents.noRole': 'Nema uloge',
  'agents.openTicketsTitle': 'Otvorene karte trenutno dodijeljene ovom agentu',
  'agents.moreActions': 'Više radnji za {name}',
  'agents.confirmDeleteTitle': 'Izbrisati {name}?',
  'agents.confirmDeleteDescription': 'Ovo se ne može poništiti. Agenti povezani s kartama ne mogu se izbrisati; umjesto toga ih deaktivirajte.',
  'agents.confirmDeleteLabel': 'Izbriši agenta',
  'agents.agentsVsCollaborators': 'Agenti u odnosu na suradnike',
  'agents.agentsVsCollaboratorsBody': 'Agenti podrške svakodnevno rade na kartama. Suradnici imaju ulogu suradnika i obično su stručnjaci pozvani na pojedine karte bez punog pristupa agenta.',
  'agents.deactivateVsDelete': 'Deaktiviranje u odnosu na brisanje',
  'agents.deactivateVsDeleteBody': 'Deaktiviranje čuva povijest i vlasništvo karata, ali blokira prijavu. Brisanje je trajno i funkcionira samo kada agent nema povezanih karata.',
  'agents.newTitle': 'Novi agent',
  'agents.editTitle': 'Uredi agenta',
  'agents.temporaryPassword': 'Privremena lozinka',
  'agents.passwordHelp': 'Najmanje 12 znakova. Agent to može promijeniti nakon prijave.',
  'agents.timezoneHelp': 'Svaki datum i vrijeme koje ovaj agent vidi prikazuje se u ovoj vremenskoj zoni.',
  'agents.languageHelp': 'Prevodi sučelje okrenuto agentu. Odgovori na karte i sadržaj kupaca se ne prevode.',
  'agents.signaturePlaceholder': 'Dodaje se odlaznim odgovorima',
  'agents.roleHelp': 'Određuje što ovaj agent može učiniti.',
  'agents.manageRoles': 'Upravljanje ulogama',
  'agents.activeHelp': 'Aktivan — poništavanje kvačice blokira prijavu bez brisanja agenta',
  'agents.groupHelp': 'Dodajte ovog agenta u grupu na zaslonu Grupe za kontrolu koje karte vidi.',
  'agents.about': 'O ovom agentu',
  'agents.aboutBody': 'Ime, e-pošta, telefon, vremenska zona, jezik i potpis identificiraju agenta i personaliziraju njegov radni prostor. Uloga određuje što može učiniti; članstvo u grupi određuje koje karte vidi.',
  'dashboard.trendsDescription': 'Stvaranje karata po UTC satu, u usporedbi s jučer.',
  'dashboard.chartAria': 'Obujam karata po UTC satu, danas u odnosu na jučer',
  'dashboard.dataUnavailable': 'Podaci nadzorne ploče nisu dostupni.',
  'dashboard.loadError': 'Nije moguće učitati podatke nadzorne ploče. Pokušajte ponovo.',
  'notifications.noType': 'Nema obavijesti ove vrste',
  'notifications.allTypesHint': 'Odaberite „Sve vrste“ iznad za prikaz ostatka povijesti.',
  'notifications.emptyDescription': 'Dodjeljivanja, odgovori i SLA upozorenja stižu ovdje. Podesite koje od njih šalju i e-poštu u postavkama obavijesti.',
  'preferences.digestWarning': 'Koristite dnevni sažetak, tako da se ove postavke zanemaruju dok ga ne isključite.',
  'preferences.assignedEvent': 'Karta vam je dodijeljena',
  'preferences.replyEvent': 'Karta na kojoj ste dobiva odgovor',
  'preferences.noteEvent': 'Dodana je privatna bilješka',
  'preferences.slaWarningEvent': 'SLA se približava svom roku',
  'preferences.slaBreachEvent': 'SLA je prekoračen',
  'preferences.slaEscalationEvent': 'SLA eskalira nakon roka',
  'preferences.mentionEvent': 'Spomenuti ste na karti',

  'ticketDetail.back': 'Natrag',
  'ticketDetail.follow': 'Pratiti',
  'ticketDetail.following': 'Pratite',
  'ticketDetail.hideActivities': 'Skrij aktivnosti',
  'ticketDetail.activitiesButton': 'Aktivnosti',
  'ticketDetail.attachmentsCount': 'Privici ({count})',
  'ticketDetail.threadAria': 'Nit karte',
  'ticketDetail.conversationsTabLabel': 'Razgovori',
  'ticketDetail.activitiesTabLabel': 'Aktivnosti',
  'ticketDetail.noRepliesYet': 'Još nema odgovora',
  'ticketDetail.noRepliesDescription': 'Koristite uređivač ispod za odgovor podnositelju ili dodavanje interne bilješke.',
  'ticketDetail.privateNote': 'Privatna bilješka',
  'ticketDetail.forward': 'Prosljeđeno',
  'ticketDetail.uploadingAria': 'Prijenos u tijeku',
  'ticketDetail.uploadingProgress': 'Prijenos {uploading} od {total} datoteka…',
  'ticketDetail.uploadsFailed': '{count} prijenosa nije uspjelo',
  'ticketDetail.retry': 'Pokušaj ponovo',
  'ticketDetail.dismiss': 'Odbaci',
  'ticketDetail.noActivityYet': 'Još nema aktivnosti',
  'ticketDetail.noActivityDescription': 'Promjene statusa, agenta i SLA-a bit će navedene ovdje kako se karta razvija.',
  'ticketDetail.requester': 'Podnositelj',
  'ticketDetail.properties': 'Svojstva',
  'ticketDetail.updating': 'Ažuriranje…',
  'ticketDetail.update': 'Ažuriraj',
  'ticketDetail.tags': 'Oznake',
  'ticketDetail.relationships': 'Odnosi',
  'ticketDetail.parentTicket': 'Roditeljska karta',
  'ticketDetail.unlink': 'Ukloni vezu',
  'ticketDetail.noParentTicket': 'Nema roditeljske karte',
  'ticketDetail.childTicketsCount': 'Podređene karte ({count})',
  'ticketDetail.noChildTickets': 'Nema podređenih karata',
  'ticketDetail.findTicket': 'Pronađi kartu',
  'ticketDetail.ticketSearchPlaceholder': 'Broj karte ili predmet',
  'ticketDetail.searchButton': 'Pretraži',
  'ticketDetail.setParent': 'Postavi kao roditeljsku',
  'ticketDetail.mergeIntoAction': 'Spoji s',
  'ticketDetail.splitIntoChild': 'Podijeli u podređenu kartu',
  'ticketDetail.newTicketSubjectPlaceholder': 'Predmet nove karte',
  'ticketDetail.splitButton': 'Podijeli',
  'ticketDetail.copyAttachments': 'Kopiraj privitke',
  'ticketDetail.copyConversationHistory': 'Kopiraj povijest razgovora',
  'ticketDetail.slaLabel': 'SLA',
  'ticketDetail.paused': 'Pauzirano',
  'ticketDetail.editButton': 'Uredi',
  'ticketDetail.setResolutionDueDate': 'Postavi rok rješavanja',
  'ticketDetail.pickDateTime': 'Odaberi datum i vrijeme',
  'ticketDetail.resolutionDueLabel': 'Rok rješavanja',
  'ticketDetail.saveSla': 'Spremi SLA',
  'ticketDetail.savingSla': 'Spremanje…',
  'ticketDetail.noSlaPolicy': 'Na ovu kartu nije primijenjeno SLA pravilo.',
  'ticketDetail.firstResponse': 'Prvi odgovor',
  'ticketDetail.resolution': 'Rješavanje',
  'ticketDetail.done': 'Gotovo',
  'ticketDetail.pausedSince': 'Pauzirano od {date}',
  'ticketDetail.escalation': 'Eskalacija',
  'ticketDetail.escalatedLevel2': 'Eskalirano (razina 2)',
  'ticketDetail.escalated': 'Eskalirano',
  'ticketDetail.dueDateOverridden': 'Rok je ručno izmijenio administrator.',
  'ticketDetail.dates': 'Datumi',
  'ticketDetail.created': 'Stvoreno',
  'ticketDetail.updated': 'Ažurirano',
  'ticketDetail.resolved': 'Riješeno',
  'ticketDetail.closed': 'Zatvoreno',
  'ticketDetail.loadErrorTitle': 'Nije moguće učitati ovu kartu',
  'ticketDetail.notFound': 'Karta nije pronađena',
  'ticketDetail.confirmMergeTitle': 'Spojiti kartu br. {source} s br. {target}?',
  'ticketDetail.confirmMergeDescription': 'Trenutna karta bit će zatvorena. Ovo se ne može poništiti.',
  'ticketDetail.confirmMergeLabel': 'Spoji kartu',
  'ticketDetail.updateSuccess': 'Karta ažurirana',
  'ticketDetail.updateError': 'Nije moguće ažurirati kartu',
  'ticketDetail.pickDateTitle': 'Odaberite datum',
  'ticketDetail.pickDateDescription': 'Odaberite rok rješavanja.',
  'ticketDetail.slaUpdateSuccess': 'SLA ažuriran',
  'ticketDetail.slaUpdateError': 'Nije moguće ažurirati SLA',
  'ticketDetail.searchError': 'Nije moguće pretražiti karte',
  'ticketDetail.parentUpdateError': 'Nije moguće ažurirati roditeljsku kartu',
  'ticketDetail.mergeSuccess': 'Spojeno s br. {number}',
  'ticketDetail.mergeError': 'Nije moguće spojiti kartu',
  'ticketDetail.splitSuccess': 'Podjela karte stvorena',
  'ticketDetail.splitError': 'Nije moguće podijeliti kartu',
  'ticketDetail.downloadError': 'Nije moguće preuzeti privitak',
  'ticketDetail.followSuccess': 'Sada pratite kartu',
  'ticketDetail.unfollowSuccess': 'Prestali ste pratiti kartu',
  'ticketDetail.watcherError': 'Nije moguće ažurirati status praćenja',
  'ticketDetail.fieldsLoadError': 'Nije moguće učitati polja karte',
  'ticketDetail.overdueBy': 'Zakasnjelo za {label}',
  'ticketDetail.dueLeft': 'Preostalo {label}',
  'ticketDetail.presetToday': 'Danas',
  'ticketDetail.presetTomorrow': 'Sutra',
  'ticketDetail.presetThisWeek': 'Ovaj tjedan',
  'ticketDetail.presetNextWeek': 'Sljedeći tjedan',
  'ticketDetail.presetThisMonth': 'Ovaj mjesec',
  'ticketDetail.eventTicketCreated': 'Karta stvorena',
  'ticketDetail.eventStatusUpdated': 'Status ažuriran',
  'ticketDetail.eventAgentUpdated': 'Agent ažuriran',
  'ticketDetail.eventSlaUpdated': 'SLA ažuriran',
  'ticketDetail.eventTicketMerged': 'Karta spojena',
  'ticketDetail.eventMergeReceived': 'Spajanje primljeno',
  'ticketDetail.eventTicketSplit': 'Karta podijeljena',
  'ticketDetail.eventUpdated': 'Ažurirano',
  'ticketDetail.eventSplitContentCopied': 'Podijeljeni sadržaj kopiran',
  'ticketDetail.eventReplySent': 'Odgovor poslan',
  'ticketDetail.eventNoteAdded': 'Bilješka dodana',
  'ticketDetail.eventCustomerReplied': 'Klijent odgovorio',
  'ticketDetail.eventTicketDeleted': 'Karta izbrisana',
  'preferences.createdEvent': 'Kreiran je ticket',
  'preferences.pendingInputEvent': 'Ticket čeka vaš odgovor',
  'preferences.resolvedEvent': 'Ticket je riješen',
  'agents.assignGroups': 'Dodijeli grupe',
  'agents.assignGroupsHelp': 'Članstvo u grupama određuje koje tickete ovaj agent može vidjeti.',
  'agents.selectGroups': 'Odaberi grupe',
  'agents.ticketVisibility': 'Vidljivost ticketa',
  'agents.ticketVisibilityHelp': 'Odaberite užu granicu po agentu ili naslijedite zadanu vrijednost uloge. Dozvole uloge i dalje određuju što agent može raditi.',
  'agents.scopeRoleDefault': 'Koristi zadanu vrijednost uloge',
  'agents.scopeRoleDefaultHelp': 'Naslijedi zadanu vidljivost konfiguriranu za ovu ulogu.',
  'agents.scopeAll': 'Svi ticketi',
  'agents.scopeAllHelp': 'Prikaži sve neizbrisane tickete u ovom računu.',
  'agents.scopeGroup': 'Ticketi u grupi',
  'agents.scopeGroupHelp': 'Prikaži tickete dodijeljene grupama kojima agent pripada.',
  'agents.scopeAssigned': 'Dodijeljeni ticketi',
  'agents.scopeAssignedHelp': 'Prikaži tickete dodijeljene izravno ovom agentu.',
  'agents.scopeCollaboratorHelp': 'Suradnici ostaju ograničeni na tickete u svojim L1 grupama.',
  'nav.jira': 'Jira integracija',
  'notifications.groupAssigned': 'Dodjela grupi',
  'notifications.groupMemberAdded': 'Dodan u grupu',
  'preferences.groupAssignedEvent': 'Zahtjev je dodijeljen jednoj od vaših grupa',
  'preferences.groupMemberAddedEvent': 'Dodani ste u grupu podrške',
  'ui.select': 'Odaberi…',
  'ui.any': 'Bilo koji',
  'ui.typeToSearch': 'Upišite za pretraživanje…',
  'ui.noResults': 'Nema pronađenih rezultata',
  'ui.clearSelection': 'Poništi odabir',
  'ui.removeItem': 'Ukloni {label}',
  'ui.pressEnterToUse': 'Pritisnite Enter za korištenje ove vrijednosti',
  'ui.removeFilter': 'Ukloni filtar {field}: {value}',
  'ui.removeTag': 'Ukloni oznaku {label}',
  'ui.retry': 'Pokušaj ponovno',
  'ui.errorTitle': 'Sadržaj nije moguće učitati',
  'ui.errorMessage': 'Provjerite vezu i pokušajte ponovno.',
  'ui.reference': 'Referenca: {id}',
  'ui.thisArea': 'ovo područje',
  'ui.noAccess': 'Nemate pristup: {area}',
  'ui.noAccessHint': 'Zamolite administratora da odobri potrebno dopuštenje.',
  'ui.actionFailed': 'Radnju nije moguće dovršiti. Pokušajte ponovno.',
  'ui.slaPaused': 'SLA pauziran',
  'ui.filteredEmptyTitle': 'Nijedan zahtjev ne odgovara ovim filtrima',
  'ui.filteredEmptyDescription': 'Pokušajte ukloniti filtar ili proširiti raspon datuma.',
  'ui.clearFilters': 'Očisti filtre',
  'pagination.noResults': 'Nema rezultata',
  'pagination.showing': 'Prikazano {first}–{last} od {total}',
  'pagination.resultsPerPage': 'Rezultata po stranici',
  'pagination.perPage': '{count} po stranici',
  'pagination.previous': 'Prethodno',
  'pagination.next': 'Sljedeće',
  'pagination.previousAria': 'Prethodna stranica',
  'pagination.nextAria': 'Sljedeća stranica',
  'pagination.pageOf': 'Stranica {page} od {total}',
  'status.open': 'Otvoren',
  'status.to_be_prioritised': 'Za određivanje prioriteta',
  'status.work_in_progress': 'U tijeku',
  'status.assigned_to_ai_agent': 'Dodijeljeno AI agentu',
  'status.cto_approval_pending': 'CTO Approval Pending',
  'status.po_approval_pending': 'PO Approval Pending',
  'status.rm_approval_pending': 'RM Approval Pending',
  'status.rework_required': 'Rework Required',
  'status.approved': 'Approved',
  'status.rejected': 'Rejected',
  'status.pending': 'Na čekanju',
  'status.awaiting_user_reply': 'Čeka odgovor korisnika',
  'status.awaiting_resolution_confirmation': 'Čeka potvrdu rješenja',
  'status.on_hold': 'Na čekanju (zadržano)',
  'status.pending_production_release': 'Čeka izdanje u produkciji',
  'status.product_cr': 'CR proizvoda',
  'status.reopened': 'Ponovno otvoren',
  'status.issue_fixed': 'Problem riješen',
  'status.resolved': 'Riješen',
  'status.closed': 'Zatvoren',
  'status.unknown': 'Nepoznato',
  'priority.low': 'Nizak',
  'priority.medium': 'Srednji',
  'priority.high': 'Visok',
  'priority.urgent': 'Hitno',
  'source.email': 'E-pošta',
  'source.portal': 'Portal',
  'source.phone': 'Telefon',
  'source.chat': 'Chat',
  'source.whatsapp': 'WhatsApp',
  'source.web_chat': 'Web chat',
  'source.web_form': 'Web obrazac',
  'source.forum': 'Forum',
  'source.facebook': 'Facebook',
  'source.mobihelp': 'MobiHelp',
  'source.feedback_widget': 'Widget za povratne informacije',
  'source.outbound_email': 'Odlazna e-pošta',
  'source.ecommerce': 'E-trgovina',
  'source.bot': 'Bot',
  'source.instagram_message': 'Instagram poruka',
  'source.instagram_comment': 'Instagram komentar',
  'source.facebook_message': 'Facebook poruka',
  'source.facebook_comment': 'Facebook komentar',
  'source.mobile_chat_sdk': 'Mobile Chat SDK',
  'source.sms': 'SMS',
  'source.api': 'API',
  'savedViews.title': 'Spremljeni prikazi',
  'savedViews.saveCurrent': 'Spremi trenutne filtre kao prikaz',
  'savedViews.namePlaceholder': 'Naziv prikaza...',
  'savedViews.nameAria': 'Naziv prikaza',
  'savedViews.empty': 'Nema spremljenih prikaza. Primijenite filtre i spremite ih ovdje.',
  'savedViews.listAria': 'Popis spremljenih prikaza',
  'savedViews.rename': 'Preimenuj prikaz „{name}“',
  'savedViews.delete': 'Izbriši prikaz „{name}“',
  'export.title': 'Izvezi zahtjeve',
  'export.loadError': 'Nije moguće učitati popis polja za izvoz.',
  'export.failed': 'Izvoz nije uspio. Pokušajte ponovno.',
  'export.pdfFailed': 'Izvoz u PDF nije uspio. Pokušajte ponovno.',
  'export.fieldsSelectedOne': 'Odabrano polje: {count}',
  'export.fieldsSelectedMany': 'Odabrano polja: {count}',
  'export.fieldsTotalOne': 'Ukupno polja: {count}',
  'export.fieldsTotalMany': 'Ukupno polja: {count}',
  'export.selectAllFields': 'Odaberi sva polja',
  'export.exportingOne': 'Izvoz 1 odabranog zahtjeva.',
  'export.exportingMany': 'Izvoz odabranih zahtjeva: {count}.',
  'export.pdfZip': 'Preuzmi kao PDF (.zip, datoteka: {count})',
  'export.pdf': 'Preuzmi kao PDF',
  'export.pdfZipHint': 'Generira jedan PDF po zahtjevu i sažima ih u jedno ZIP preuzimanje.',
  'export.pdfHint': 'Generira jedan PDF sa svojstvima zahtjeva i javnom niti razgovora.',
  'export.formatLabel': 'Izvezi kao (CSV / Excel)',
  'export.csv': 'CSV',
  'export.excel': 'Excel',
  'export.loadingFields': 'Učitavanje popisa polja…',
  'export.ticketFields': 'Polja zahtjeva',
  'export.contactFields': 'Polja kontakta',
  'export.companyFields': 'Polja tvrtke',
  'export.exporting': 'Izvoz u tijeku…',
  'newTicket.title': 'Izradi zahtjev',
  'newTicket.description': 'Odaberite spremljeni obrazac i ispunite njegova polja.',
  'newTicket.form': 'Obrazac zahtjeva',
  'newTicket.noForms': 'Nema dostupnih obrazaca zahtjeva. Konfigurirajte obrazac prije izrade zahtjeva.',
  'newTicket.loadFormsError': 'Nije moguće učitati obrasce zahtjeva',
  'newTicket.loadFormError': 'Nije moguće učitati odabrani obrazac zahtjeva',
  'newTicket.addCc': 'Dodaj CC',
  'newTicket.cc': 'CC',
  'newTicket.removeFile': 'Ukloni {name}',
  'newTicket.requesterRequired': 'Podnositelj zahtjeva je obavezan',
  'newTicket.subjectRequired': 'Predmet je obavezan',
  'newTicket.createFailed': 'Izrada zahtjeva nije uspjela',
  'newTicket.noFormTitle': 'Nema dostupnog obrasca zahtjeva',
  'newTicket.noFormDescription': 'Izradite obrazac zahtjeva u Postavkama, zatim se vratite i otvorite zahtjev.',
  'newTicket.noFieldsTitle': 'Ovaj obrazac još nema polja',
  'newTicket.noFieldsDescription': 'Dodajte polja obrascu u Postavkama, zatim ponovno učitajte ovu stranicu.',
  'newTicket.creating': 'Izrada…',
  'newTicket.submit': 'Izradi zahtjev',
  'fields.required': '{label} je obavezno',
  'fields.selectParentFirst': 'Prvo odaberite nadređenu vrijednost...',
  'fields.selectPlaceholder': 'Odaberi {label}...',
  'fields.enterPlaceholder': 'Unesite {label}...',
  'fields.optionsLoadError': 'Nije moguće učitati opcije za {label}',
  'fields.label.requester': 'Podnositelj zahtjeva',
  'fields.label.subject': 'Predmet',
  'fields.label.description': 'Opis',
  'fields.label.status': 'Status',
  'fields.label.priority': 'Prioritet',
  'fields.label.source': 'Izvor',
  'fields.label.ticket_type': 'Vrsta',
  'fields.label.agent': 'Agent',
  'fields.label.group': 'Grupa',
  'fields.label.internal_agent': 'Interni agent',
  'fields.label.internal_group': 'Interna grupa',
  'fields.label.company': 'Tvrtka',
  'editor.defaultPlaceholder': 'Upišite ovdje...',
  'editor.ariaLabel': 'Uređivač obogaćenog teksta',
  'editor.toolbarAria': 'Oblikovanje teksta',
  'editor.bold': 'Podebljano (Ctrl+B)',
  'editor.italic': 'Kurziv (Ctrl+I)',
  'editor.underline': 'Podcrtano (Ctrl+U)',
  'editor.strikethrough': 'Prekriženo',
  'editor.heading1': 'Naslov 1',
  'editor.heading2': 'Naslov 2',
  'editor.textColor': 'Boja teksta',
  'editor.highlight': 'Istaknuto',
  'editor.bulletList': 'Popis s oznakama',
  'editor.numberedList': 'Numerirani popis',
  'editor.blockquote': 'Citat',
  'editor.codeBlock': 'Blok koda',
  'editor.insertLink': 'Umetni poveznicu',
  'editor.insertImage': 'Umetni sliku',
  'editor.insertTable': 'Umetni tablicu',
  'editor.mention': 'Spomeni nekoga',
  'editor.undo': 'Poništi (Ctrl+Z)',
  'editor.redo': 'Ponovi (Ctrl+Shift+Z)',
  'editor.attach': 'Priloži datoteku',
  'editor.noAgents': 'Nema pronađenih agenata',
  'editor.mentionSuggestions': 'Prijedlozi za spominjanje',
  'editor.dialogLinkTitle': 'Umetni poveznicu',
  'editor.dialogImageTitle': 'Umetni sliku',
  'editor.linkHint': 'Unesite HTTP(S), mailto, sidreni ili relativni URL.',
  'editor.imageHint': 'Unesite HTTP(S) ili relativni URL slike.',
  'editor.url': 'URL',
  'editor.invalidLink': 'Unesite valjani HTTP(S), mailto, sidreni ili relativni URL.',
  'editor.invalidImage': 'Unesite valjani HTTP(S) ili relativni URL slike.',
  'editor.selectTextForLink': 'Odaberite tekst prije dodavanja poveznice.',
  'editor.imageInsertFailed': 'Sliku nije moguće umetnuti ovdje.',
  'editor.insertLinkAction': 'Umetni poveznicu',
  'editor.insertImageAction': 'Umetni sliku',
  'search.dialogAria': 'Globalno pretraživanje',
  'search.placeholder': 'Pretraži zahtjeve, kontakte...',
  'search.aria': 'Pretraži',
  'search.close': 'Zatvori pretraživanje',
  'search.noMatches': 'Nema rezultata za „{query}“',
  'search.noMatchesHint': 'Pokušajte s brojem zahtjeva, e-poštom kontakta ili nazivom tvrtke.',
  'search.hintBefore': 'Upišite najmanje 2 znaka za pretraživanje. Pritisnite',
  'search.hintAfter': 'za zatvaranje.',

  'td.system': 'Sustav',
  'td.actionCreatedTicket': 'stvorio/la kartu',
  'td.actionUpdatedFields': 'ažurirao/la: {fields}',
  'td.fieldStatus': 'status',
  'td.fieldPriority': 'prioritet',
  'td.fieldSource': 'izvor',
  'td.fieldType': 'vrsta',
  'td.fieldGroup': 'grupa',
  'td.fieldAgent': 'agent',
  'td.fieldCompany': 'tvrtka',
  'td.fieldContact': 'kontakt',
  'td.fieldSubject': 'predmet',
  'td.fieldDescription': 'opis',
  'td.fieldProduct': 'proizvod',
  'td.fieldResolutionDue': 'rok rješavanja',
  'td.fieldFirstResponseDue': 'rok prvog odgovora',
  'td.fieldTags': 'oznake',
  'td.fieldParentTicket': 'roditeljska karta',
  'td.eventCreated': '{actor} je stvorio/la novu kartu',
  'td.eventCreatedLinked': '{actor} je stvorio/la novu kartu i povezao/la je s roditeljskom kartom',
  'td.eventSplit': '{actor} je podijelio/la ovu kartu i stvorio/la podređenu kartu{ref}',
  'td.eventMergeReceived': '{actor} je spojio/la drugu kartu s ovom kartom{ref}',
  'td.eventMerged': '{actor} je spojio/la ovu kartu s drugom kartom{ref}',
  'td.eventSplitCopied': '{actor} je kopirao/la: {conversations} i {attachments}',
  'td.conversationsOne': '{count} razgovor',
  'td.conversationsMany': '{count} razgovora',
  'td.attachmentsOne': '{count} privitak',
  'td.attachmentsMany': '{count} privitaka',
  'td.eventUpdatedFields': '{actor} je ažurirao/la: {fields}',
  'td.invalidSlaState': 'Poslužitelj je vratio neispravno SLA stanje.',
  'td.slaRefreshError': 'Nije moguće osvježiti SLA satove.',
  'td.descriptionUpdated': 'Opis je ažuriran',
  'td.descriptionUpdateError': 'Nije moguće ažurirati opis',
  'td.descriptionUpdateFailed': 'Ažuriranje opisa nije uspjelo',
  'td.entryUpdated': 'Unos je ažuriran',
  'td.entryUpdateError': 'Nije moguće ažurirati unos',
  'td.updateFailed': 'Ažuriranje nije uspjelo',
  'td.loadOlderError': 'Nije moguće učitati starije razgovore',
  'td.loadFailed': 'Učitavanje nije uspjelo',
  'td.slaUpdateFailed': 'Ažuriranje SLA-a nije uspjelo',
  'td.reasonTooLong': 'Razlog može imati najviše 500 znakova.',
  'td.invalidDateTime': 'Odaberite ispravan datum i vrijeme.',
  'td.slaDeadlineUpdated': 'SLA rok je ažuriran',
  'td.slaConflict': 'Karta se promijenila dok ste uređivali SLA podatke. Ponovno učitajte prije nego pokušate ponovo.',
  'td.slaClearFailed': 'Brisanje SLA-a nije uspjelo',
  'td.slaTargetCleared': 'SLA cilj je obrisan',
  'td.slaClearError': 'Nije moguće obrisati SLA cilj',
  'td.noDescription': 'Opis još nije dodan.',
  'td.editDescriptionAria': 'Uredi opis karte',
  'td.download': 'Preuzmi',
  'td.downloadFile': 'Preuzmi {fileName}',
  'td.loadOlder': '↓ +{count} razgovor',
  'td.loadOlderMany': '↓ +{count} razgovora',
  'td.edited': '(uređeno)',
  'td.privateThread': 'Privatna nit',
  'td.propertiesAria': 'Svojstva karte',
  'td.expandProperties': 'Proširi svojstva',
  'td.collapseProperties': 'Skupi svojstva',
  'td.metric': 'Metrika',
  'td.firstResponseOption': 'Prvi odgovor',
  'td.resolutionOption': 'Rješavanje',
  'td.overrideHint': 'Postavite rok koji nadjačava poslužitelj. Razlog se čuva u SLA povijesti.',
  'td.deadline': 'Rok',
  'td.reasonOptional': 'Razlog (neobavezno)',
  'td.reasonPlaceholder': 'Odobrena iznimka ili operativni kontekst',
  'td.clearResolutionOverride': 'Ukloni nadjačavanje rješavanja',
  'td.clearEscalationTarget': 'Ukloni cilj eskalacije',
  'td.toolsAria': 'Alati karte i kontakt',
  'td.ticketContext': 'Kontekst karte',
  'td.knowledgeBase': 'Baza znanja',
  'td.shortcutsAria': 'Prečaci konteksta karte',
  'td.showContext': 'Prikaži kontekst karte',
  'td.hideContext': 'Sakrij kontekst karte',
  'td.openRow': 'Otvori {label}',
  'td.editTicket': 'Uredi kartu',
  'td.searchContactPlaceholder': 'Pretraži kontakt…',
  'td.describePlaceholder': 'Opišite problem…',
  'td.noAttachments': 'Nema privitaka',

  'tp.api.csrfUnavailable': 'Nije moguće uspostaviti CSRF zaštitu',
  'tp.api.noMfaChallenge': 'Nema aktivnog MFA izazova',
  'tp.api.noMfaSetup': 'Nema aktivnog izazova za postavljanje MFA',
  'tp.api.noNewPasswordChallenge': 'Nema aktivnog izazova za novu lozinku',
  'tp.articles.isLinkedAria': '{title} je povezan kao rješenje',
  'tp.articles.linkAria': 'Poveži {title} kao rješenje',
  'tp.articles.linkAsSolution': 'Poveži kao rješenje',
  'tp.articles.linkedAsSolution': 'Povezano kao rješenje',
  'tp.articles.none': 'Nema predloženih članaka za ovu kartu.',
  'tp.articles.title': 'Predloženi članci',
  'tp.articles.views': '{count} pregleda',
  'tp.attachment.loadingPreview': 'Učitavanje pregleda…',
  'tp.attachment.previewUnavailable': 'Pregled nije dostupan',
  'tp.charts.noData': 'Nema podataka grafikona za ovo razdoblje.',
  'tp.charts.noRecords': 'Nema zapisa u ovom razdoblju.',
  'tp.charts.period': 'Razdoblje',
  'tp.charts.showingTop': 'Prikazano je prvih {shown} od {total} segmenata.',
  'tp.common.cancel': 'Odustani',
  'tp.common.clear': 'Očisti',
  'tp.common.loading': 'Učitavanje…',
  'tp.common.send': 'Pošalji',
  'tp.common.sending': 'Slanje…',
  'tp.common.system': 'Sustav',
  'tp.convActions.edit': 'Uredi',
  'tp.convActions.thread': 'Započni nit',
  'tp.dashboard.new': 'Nova',
  'tp.dashboard.select': 'Odaberi nadzornu ploču',
  'tp.forward.failed': 'Prosljeđivanje nije uspjelo',
  'tp.forward.forwarded': 'Karta je proslijeđena',
  'tp.forward.forwarding': 'Prosljeđivanje…',
  'tp.forward.forwardingMany': 'Prosljeđivanje razgovora: {count}',
  'tp.forward.forwardingOne': 'Prosljeđivanje razgovora: 1',
  'tp.forward.message': 'Poruka',
  'tp.forward.messagePlaceholder': 'Dodajte poruku (neobavezno)…',
  'tp.forward.noContacts': 'Nema pronađenih kontakata — upišite punu adresu e-pošte',
  'tp.forward.recipientEmail': 'E-pošta primatelja',
  'tp.forward.recipientInvalid': 'Unesite ispravnu adresu e-pošte primatelja',
  'tp.forward.recipientRequired': 'E-pošta primatelja je obavezna',
  'tp.forward.searchContact': 'Pretražite kontakt ili upišite e-poštu…',
  'tp.forward.title': 'Proslijedi',
  'tp.forward.to': 'Za',
  'tp.forward.useThisEmail': 'Pritisnite Enter ili kliknite Proslijedi za korištenje ove e-pošte',
  'tp.jira.addOptional': 'Dodaj neobavezna polja',
  'tp.jira.createAndLink': 'Stvori i poveži zadatak',
  'tp.jira.createIssue': 'Stvori zadatak',
  'tp.jira.createTitle': 'Stvori Jira zadatak',
  'tp.jira.describePlaceholder': 'Opišite problem…',
  'tp.jira.description': 'Opis',
  'tp.jira.development': 'Razvoj',
  'tp.jira.enterDevelopment': 'Unesite razvoj',
  'tp.jira.hideOptional': 'Sakrij neobavezna polja',
  'tp.jira.issueId': 'ID zadatka',
  'tp.jira.issueSummary': 'Sažetak zadatka',
  'tp.jira.issueType': 'Vrsta zadatka *',
  'tp.jira.lastSync': 'Zadnja sinkronizacija: {error}',
  'tp.jira.linkIssue': 'Poveži zadatak',
  'tp.jira.linkTitle': 'Poveži Jira zadatak',
  'tp.jira.linkedIssues': 'Povezani zadaci',
  'tp.jira.linkedIssuesHint': 'Koristite Jira ključeve zadataka odvojene zarezima.',
  'tp.jira.linkedIssuesPlaceholder': 'npr. SUP-123, SUP-456',
  'tp.jira.loadingFields': 'Učitavanje Jira polja…',
  'tp.jira.loadingIssueTypes': 'Učitavanje vrsta zadataka…',
  'tp.jira.loadingProjects': 'Učitavanje Jira projekata…',
  'tp.jira.loadingUsers': 'Učitavanje Jira korisnika…',
  'tp.jira.noLinks': 'Na ovu kartu još nije povezan nijedan Jira zadatak.',
  'tp.jira.noneFound': 'Nijedan Jira zadatak nije pronađen.',
  'tp.jira.notAvailableProject': 'Nije dostupno za ovaj projekt',
  'tp.jira.projects': 'Projekti *',
  'tp.jira.refresh': 'Osvježi',
  'tp.jira.refreshFields': 'Osvježi Jira polja',
  'tp.jira.reporter': 'Prijavitelj',
  'tp.jira.requestFailed': 'Jira zahtjev nije uspio. Pokušajte ponovo.',
  'tp.jira.searchBy': 'Pretraži po:',
  'tp.jira.searchIssue': 'Pretraži zadatak',
  'tp.jira.searchIssuePlaceholder': 'Pretraži zadatak…',
  'tp.jira.searchUsers': 'Pretraži Jira korisnike',
  'tp.jira.searching': 'Pretraživanje Jire…',
  'tp.jira.selectIssueType': 'Odaberite vrstu zadatka',
  'tp.jira.selectProject': 'Odaberite projekt',
  'tp.jira.summary': 'Sažetak *',
  'tp.jira.syncOff': 'Sinkronizacija isključena',
  'tp.jira.syncOn': 'Sinkronizacija uključena',
  'tp.jira.syncStatus': 'Sinkroniziraj status karte s Jirom',
  'tp.jira.unassigned': 'Nedodijeljeno',
  'tp.jira.unlink': 'Ukloni vezu',
  'tp.jira.unlinkConfirm': 'Ukloni vezu sa zadatkom',
  'tp.jira.unlinkDescription': 'Time se uklanja veza s kartom, ali se Jira zadatak ne briše.',
  'tp.jira.unlinkTitle': 'Ukloniti vezu {key}?',
  'tp.jira.untitled': 'Jira zadatak bez naslova',
  'tp.layout.loadingPage': 'Učitavanje stranice…',
  'tp.notFound.goToDashboard': 'Idi na nadzornu ploču',
  'tp.notFound.title': 'Stranica nije pronađena',
  'tp.portal.brand': 'SuzukiDesk podrška',
  'tp.portal.customer': 'Klijent',
  'tp.reply.addNote': 'Dodaj bilješku',
  'tp.reply.attachmentNotAdded': 'Privitak nije dodan',
  'tp.reply.clickToExpand': 'Kliknite za proširenje',
  'tp.reply.collapsedNote': 'Dodajte internu bilješku…',
  'tp.reply.collapsedReply': 'Napišite odgovor ili bilješku…',
  'tp.reply.conversationType': 'Vrsta razgovora',
  'tp.reply.failedToSend': 'Slanje nije uspjelo',
  'tp.reply.markNoteAs': 'Označi bilješku kao',
  'tp.reply.notVisibleToContact': 'Nije vidljivo kontaktu',
  'tp.reply.notVisibleToContacts': 'Nije vidljivo kontaktima',
  'tp.reply.noteAdded': 'Bilješka je dodana',
  'tp.reply.notifyTo': 'Obavijesti',
  'tp.reply.placeholderPrivateNote': 'Dodajte privatnu bilješku...',
  'tp.reply.placeholderPublicNote': 'Dodajte javnu bilješku vidljivu podnositelju...',
  'tp.reply.placeholderReply': 'Upišite svoj odgovor...',
  'tp.reply.private': 'Privatno',
  'tp.reply.public': 'Javno',
  'tp.reply.removeFile': 'Ukloni {name}',
  'tp.reply.replySent': 'Odgovor je poslan',
  'tp.reply.searchAgentsToNotify': 'Pretražite agente za obavijest…',
  'tp.reply.sendReply': 'Pošalji odgovor',
  'tp.reply.sending': 'Slanje...',
  'tp.reply.tabNote': 'Bilješka',
  'tp.reply.tabReply': 'Odgovor',
  'tp.reply.uploadAttachment': 'Prenesi privitak',
  'tp.reply.visibleToContact': 'Vidljivo kontaktu',
  'tp.reply.visibleToContacts': 'Vidljivo kontaktima',
  'tp.sla.breached': 'Prekoračeno',
  'tp.sla.cleared': 'Obrisano',
  'tp.sla.configErrorNoDeadline': 'Pogreška SLA konfiguracije. Rok se ne zaključuje.',
  'tp.sla.configurationError': 'Pogreška konfiguracije',
  'tp.sla.couldNotLoad': 'Nije moguće učitati SLA satove',
  'tp.sla.done': 'Gotovo',
  'tp.sla.dueIn': 'Rok za {duration}',
  'tp.sla.dueLine': 'Rok: {date}',
  'tp.sla.dueNow': 'Rok je sada',
  'tp.sla.escalated': 'Eskalirano',
  'tp.sla.firstResponse': 'Prvi odgovor',
  'tp.sla.invalidDeadline': 'Neispravan rok',
  'tp.sla.mayBeStale': 'SLA satovi možda nisu ažurni',
  'tp.sla.noActiveCycle': 'Nema aktivnog SLA ciklusa.',
  'tp.sla.noDeadline': 'Nema roka',
  'tp.sla.noMetrics': 'Nema dostupnih SLA metrika za ovaj ciklus.',
  'tp.sla.noPolicy': 'Na ovu kartu nije primijenjeno SLA pravilo.',
  'tp.sla.notConfigured': 'Nije konfigurirano',
  'tp.sla.notStarted': 'Nije započeto',
  'tp.sla.overdueBy': 'Zakasnjelo za {duration}',
  'tp.sla.overridden': 'Nadjačano',
  'tp.sla.overrideReason': 'Razlog nadjačavanja: {reason}',
  'tp.sla.paused': 'Pauzirano',
  'tp.sla.refreshing': 'Osvježavanje mjerodavnih SLA satova…',
  'tp.sla.resolution': 'Rješavanje',
  'tp.sla.stopsSla': 'Zaustavlja SLA',
  'tp.thread.empty': 'Još ništa nije poslano. Vaša prva poruka pokrenut će ovu privatnu nit.',
  'tp.thread.messageFailed': 'Poruka nije poslana',
  'tp.thread.privateThread': 'Privatna nit',
  'tp.thread.replyPlaceholder': 'Odgovorite u niti…',
  'tp.thread.someone': 'Netko',
  'tp.thread.startPrivateThread': 'Započni privatnu nit',
  'tp.thread.startedBy': '{name} je započeo/la ovu nit',
  'tp.thread.unableToSend': 'Nije moguće poslati poruku',
  'tp.ui.breadcrumb': 'Putanja',
  'tp.ui.closePanel': 'Zatvori ploču',
  'tp.ui.dismiss': 'Odbaci {title}',

  'dir.loadError': 'Nije moguće učitati podatke. Pokušajte ponovo.',
  'dir.contacts.description': 'Kontakti klijenata i njihova povijest podrške.',
  'dir.contacts.searchAria': 'Pretraži kontakte',
  'dir.contacts.count': '{count} kontakata',
  'dir.contacts.noMatch': 'Nijedan kontakt ne odgovara pretraživanju',
  'dir.contacts.none': 'Još nema kontakata',
  'dir.contacts.noneDescription': 'Kontakti će se ovdje prikazati kada klijenti počnu slati karte.',
  'dir.company': 'Tvrtka',
  'dir.unnamedContact': 'Kontakt bez imena',
  'dir.contact': 'Kontakt',
  'dir.contactNotFound': 'Kontakt nije pronađen.',
  'dir.confirmDeleteContactTitle': 'Izbrisati „{name}“?',
  'dir.thisContact': 'ovaj kontakt',
  'dir.confirmDeleteContactDescription': 'Kontakti s kartama bit će deaktivirani umjesto trajno izbrisani.',
  'dir.deleteContact': 'Izbriši kontakt',
  'dir.editProfile': 'Uredi profil',
  'dir.profile': 'Profil',
  'dir.firstName': 'Ime',
  'dir.lastName': 'Prezime',
  'dir.phone': 'Telefon',
  'dir.timezone': 'Vremenska zona',
  'dir.emailLabel': 'E-pošta:',
  'dir.phoneLabel': 'Telefon:',
  'dir.companyLabel': 'Tvrtka:',
  'dir.timezoneLabel': 'Vremenska zona:',
  'dir.recentTickets': 'Nedavne karte',
  'dir.noTicketsYet': 'Još nema karata',
  'dir.contactTicketsDescription': 'Karte koje je podnio ovaj kontakt bit će navedene ovdje.',
  'dir.ticket': 'Karta',
  'dir.subject': 'Predmet',
  'dir.status': 'Status',
  'dir.created': 'Stvoreno',
  'dir.companies.description': 'Organizacije povezane s kontaktima klijenata i kartama.',
  'dir.companies.add': 'Dodaj tvrtku',
  'dir.companies.domain': 'Domena',
  'dir.companies.create': 'Stvori tvrtku',
  'dir.companies.searchAria': 'Pretraži tvrtke',
  'dir.companies.searchPlaceholder': 'Pretraži tvrtke ili domene',
  'dir.companies.noMatch': 'Nijedna tvrtka ne odgovara pretraživanju',
  'dir.companies.addFirst': 'Dodajte svoju prvu tvrtku',
  'dir.companies.tryDifferent': 'Pokušajte s drugim nazivom tvrtke ili domenom.',
  'dir.companies.useForm': 'Koristite obrazac pored ovog popisa za stvaranje tvrtke.',
  'dir.companies.contacts': 'Kontakti',
  'dir.companies.tickets': 'Karte',
  'dir.companies.notFound': 'Tvrtka nije pronađena.',
  'dir.companies.confirmDeleteTitle': 'Izbrisati „{name}“?',
  'dir.companies.thisCompany': 'ova tvrtka',
  'dir.companies.confirmDeleteDescription': 'Tvrtka ne smije imati kontakte ni karte da bi se mogla izbrisati.',
  'dir.companies.delete': 'Izbriši tvrtku',
  'dir.companies.noDomain': 'Domena nije konfigurirana',
  'dir.companies.contactsCount': 'Kontakti ({count})',
  'dir.companies.ticketsCount': 'Karte ({count})',
  'dir.companies.noContactsDescription': 'Dodajte kontakt i povežite ga s ovom tvrtkom da biste ga vidjeli ovdje.',
  'dir.companies.noTicketsDescription': 'Karte koje su podnijeli kontakti ove tvrtke bit će navedene ovdje.',
  'dir.trendsCreatedHour': 'Datum stvaranja - sat u danu',
  'dir.reports.loadError': 'Nije moguće učitati ovo izvješće. Pokušajte ponovo.',
  'dir.reports.volume': 'Obujam karata',
  'dir.reports.sla': 'Usklađenost sa SLA',
  'dir.reports.agents': 'Učinak agenata',
  'dir.reports.csat': 'Zadovoljstvo klijenata',
  'dir.reports.rca': 'Analiza uzroka',
  'dir.reports.descVolume': 'Pogledajte odakle dolaze karte i kako prolaze kroz životni ciklus.',
  'dir.reports.descSla': 'Pratite ciljeve odgovora i rješavanja u dostupnom dijelu podrške.',
  'dir.reports.descAgents': 'Usporedite opterećenje, ishode, odgovore i prosječna vremena obrade po agentu.',
  'dir.reports.descCsat': 'Čitajte raspoloženje klijenata bez miješanja broja odgovora sa stopom zadovoljstva.',
  'dir.reports.descRca': 'Pronađite standardizirane uzroke potražnje za kartama.',
  'dir.reports.noPayload': 'Za ovo razdoblje nisu vraćeni podaci izvješća.',
  'dir.reports.refresh': 'Osvježi',
  'dir.reports.report': 'Izvješće',
  'dir.reports.from': 'Od',
  'dir.reports.to': 'Do',
  'dir.reports.maxRange': 'Maksimalni raspon: 90 dana · opseg slijedi dopuštenja vašeg računa.',
  'dir.reports.unclassified': 'Nerazvrstano',
  'dir.reports.ticketsInPeriod': 'Karte u razdoblju',
  'dir.reports.ticketsInPeriodDetail': 'Dostupne karte vraćene u izvješću',
  'dir.reports.created': 'Stvoreno',
  'dir.reports.createdDetail': 'Kroz odabranu vremensku os',
  'dir.reports.resolved': 'Riješeno',
  'dir.reports.resolvedDetail': '{percent}% stvorenog obujma',
  'dir.reports.noCreated': 'Nema stvorenih karata',
  'dir.reports.reopened': 'Ponovno otvoreno',
  'dir.reports.reopenedDetail': 'Događaji životnog ciklusa, a ne jedinstvene karte',
  'dir.reports.dailyPulse': 'Dnevni puls',
  'dir.reports.volumeByDate': 'Obujam karata po datumu',
  'dir.reports.volumeByDateDescription': 'Rijetki redovi iz pozadinskog sustava proširuju se u potpunu vremensku os popunjenu nulama.',
  'dir.reports.createdTickets': 'Stvorene karte',
  'dir.reports.createdVolumeAria': 'Obujam stvorenih karata po datumu',
  'dir.reports.lifecycle': 'Životni ciklus',
  'dir.reports.lifecycleTitle': 'Stvoreno, riješeno, ponovno otvoreno',
  'dir.reports.lifecycleDescription': 'Prikaz kretanja kroz životni ciklus karte u tri linije.',
  'dir.reports.lifecycleAria': 'Događaji životnog ciklusa karata po datumu',
  'dir.reports.dimensions': 'Dimenzije',
  'dir.reports.whereConcentrated': 'Gdje je obujam koncentriran',
  'dir.reports.topEight': 'Prikazano je prvih osam segmenata po ploči',
  'dir.reports.status': 'Status',
  'dir.reports.statusDescription': 'Trenutni status karte',
  'dir.reports.priority': 'Prioritet',
  'dir.reports.priorityDescription': 'Raspodjela prioriteta karata',
  'dir.reports.group': 'Grupa',
  'dir.reports.groupDescription': 'Grupe za usmjeravanje',
  'dir.reports.agent': 'Agent',
  'dir.reports.agentDescription': 'Dodijeljeno vlasništvo',
  'dir.reports.product': 'Proizvod',
  'dir.reports.productDescription': 'Raspodjela proizvoda',
  'dir.reports.country': 'Država',
  'dir.reports.countryDescription': 'Iz standardiziranih polja države',
  'dir.reports.noRecords': 'Nema zapisa u ovom razdoblju.',
  'dir.reports.slaSummary': '{rate} · ispunjeno {met} od {total}',
  'dir.reports.noSlaSegments': 'Još nema SLA segmenata',
  'dir.reports.noSlaSegmentsDescription': 'Nema primjenjivih SLA zapisa za ovu dimenziju u odabranom razdoblju.',
  'dir.reports.segment': 'Segment',
  'dir.reports.firstResponse': 'Prvi odgovor',
  'dir.reports.resolution': 'Rješavanje',
  'dir.reports.avgFirstResponse': 'Prosj. prvi odgovor',
  'dir.reports.avgResolution': 'Prosj. rješavanje',
  'dir.reports.fromTicketMetric': 'Iz TicketMetric',
  'dir.reports.slaLens': 'SLA pogled',
  'dir.reports.performanceBySegment': 'Učinak po segmentu',
  'dir.reports.slaRatesNote': 'Stope koriste samo zapise s primjenjivim SLA ciljem. Trajanja su prosječno proteklo vrijeme.',
  'dir.reports.slaDimensionAria': 'Dimenzija SLA raščlambe',
  'dir.reports.rosterSignal': 'Signal popisa',
  'dir.reports.agentPerformance': 'Učinak agenata',
  'dir.reports.agentPerformanceDescription': 'Uključen je svaki aktivni agent, uključujući agente bez aktivnosti.',
  'dir.reports.filterAgentsAria': 'Filtriraj agente',
  'dir.reports.filterAgentsPlaceholder': 'Filtriraj po agentu ili e-pošti',
  'dir.reports.matchingAgents': '{count} odgovarajućih agenata',
  'dir.reports.activeAgents': '{count} aktivnih agenata',
  'dir.reports.sortedBy': 'sortirano po {key} {direction}',
  'dir.reports.asc': 'uzlazno',
  'dir.reports.desc': 'silazno',
  'dir.reports.noAgentsMatch': 'Nijedan agent ne odgovara ovom filtru',
  'dir.reports.assigned': 'Dodijeljeno',
  'dir.reports.replies': 'Odgovori',
  'dir.reports.csatScore': 'CSAT ocjena',
  'dir.reports.csatScoreDetail': 'Ocjene 4 ili 5',
  'dir.reports.averageRating': 'Prosječna ocjena',
  'dir.reports.averageRatingDetail': 'Kroz ocijenjene ankete',
  'dir.reports.ratedSurveys': 'Ocijenjene ankete',
  'dir.reports.ratedSurveysDetail': 'U odabranom razdoblju',
  'dir.reports.satisfied': 'Zadovoljni',
  'dir.reports.satisfiedDetail': 'Pozitivni odgovori',
  'dir.reports.responseTrend': 'Trend odgovora',
  'dir.reports.surveyVolume': 'Obujam anketa po datumu',
  'dir.reports.surveyVolumeDescription': 'Pozadinski sustav vraća broj odgovora po datumu; to nije dnevna ocjena. Dolje je uzorkovano zadnjih 100 odgovora.',
  'dir.reports.surveyResponses': 'Odgovori na ankete',
  'dir.reports.surveyVolumeAria': 'Obujam odgovora na CSAT ankete po datumu',
  'dir.reports.responsesByGroup': 'Odgovori po grupi',
  'dir.reports.responsesByGroupDescription': 'Broj odgovora na ankete, a ne stopa zadovoljstva grupe',
  'dir.reports.responsesByAgent': 'Odgovori po agentu',
  'dir.reports.responsesByAgentDescription': 'Broj odgovora na ankete, a ne stopa zadovoljstva agenta',
  'dir.reports.customerVoice': 'Glas klijenata',
  'dir.reports.latestSurveys': 'Najnoviji odgovori na ankete',
  'dir.reports.boundedSample': 'Ograničeni uzorak · {count} od najviše 100',
  'dir.reports.latestSurveysNote': 'Najnoviji odgovori koje vraća API za izvješćivanje. Koristite ovu tablicu za brz pregled, a ne za potpuni izvoz.',
  'dir.reports.noSurveys': 'Nema odgovora na ankete',
  'dir.reports.noSurveysDescription': 'CSAT odgovori pojavit će se ovdje kada klijenti ocijene riješenu kartu.',
  'dir.reports.rating': 'Ocjena',
  'dir.reports.comment': 'Komentar',
  'dir.reports.received': 'Primljeno',
  'dir.reports.ratingOutOf': '{rating} od 5',
  'dir.reports.noComment': 'Nema komentara',
  'dir.reports.rcaEyebrow': 'Analiza uzroka',
  'dir.reports.rcaTitle': 'Zašto se podnose karte',
  'dir.reports.rcaDescription': 'Kategorija i potkategorija neovisni su agregati iz standardiziranih prilagođenih polja karte.',
  'dir.reports.rcaDimensionAria': 'RCA dimenzija',
  'dir.reports.category': 'Kategorija',
  'dir.reports.subcategory': 'Potkategorija',
  'dir.reports.rcaEmpty': 'Za ovo razdoblje nisu zabilježene vrijednosti uzroka.',
  'dir.kb.articleLoadError': 'Nije moguće učitati članak.',
  'dir.kb.articleNotFound': 'Članak nije pronađen.',
  'dir.kb.retry': 'Pokušaj ponovo',
  'dir.kb.title': 'Baza znanja',
  'dir.kb.breadcrumb': 'Baza znanja',
  'dir.kb.description': 'Članci: {articles}, mape: {folders}',
  'dir.kb.newArticle': 'Novi članak',
  'dir.kb.editArticle': 'Uredi članak',
  'dir.kb.sectionsAria': 'Odjeljci baze znanja',
  'dir.kb.tabArticles': 'Članci',
  'dir.kb.tabStructure': 'Kategorije i mape',
  'dir.kb.folderFilterAria': 'Filtar mapa',
  'dir.kb.allArticles': 'Svi članci ({count})',
  'dir.kb.writeFirst': 'Napišite svoj prvi članak',
  'dir.kb.writeFirstDescription': 'Koristite Novi članak za dodavanje sadržaja u ovu mapu.',
  'dir.kb.byAuthor': 'autor: {name}',
  'dir.kb.views': '{count} pregleda',
  'dir.kb.published': 'Objavljeno',
  'dir.kb.draft': 'Skica',
  'dir.kb.publish': 'Objavi',
  'dir.kb.unpublish': 'Povuci objavu',
  'dir.kb.noFolders': 'Nema mapa u ovoj kategoriji',
  'dir.kb.noFoldersDescription': 'Dodajte mapu za početak grupiranja članaka.',
  'dir.kb.articlesCount': '{count} članaka',
  'dir.kb.fieldTitle': 'Naslov',
  'dir.kb.folder': 'Mapa',
  'dir.kb.selectFolder': 'Odaberi mapu',
  'dir.kb.content': 'Sadržaj',
  'dir.kb.contentPlaceholder': 'Napišite sadržaj članka...',
  'dir.kb.tags': 'Oznake (odvojene zarezima)',
  'dir.kb.attachments': 'Privici',
  'dir.kb.download': 'Preuzmi',
  'dir.kb.downloadFile': 'Preuzmi {name}',
  'dir.kb.remove': 'Ukloni',
  'dir.kb.removeFile': 'Ukloni {name}',
  'dir.kb.noAttachments': 'Još nema privitaka.',
  'dir.kb.uploadAria': 'Prenesi privitak',
  'dir.kb.uploading': 'Prijenos...',
  'dir.kb.addFile': 'Dodaj datoteku',
  'dir.kb.confirmDeleteTitle': 'Izbrisati članak?',
  'dir.kb.confirmDeleteDescription': 'Ovaj objavljeni članak ili skica bit će trajno izbrisan.',
  'dir.kb.confirmDeleteLabel': 'Izbriši članak',
  'dir.kb.confirmRemoveTitle': 'Ukloniti privitak?',
  'dir.kb.confirmRemoveDescription': 'Datoteka će biti trajno uklonjena iz ovog članka.',
  'dir.kb.confirmRemoveLabel': 'Ukloni privitak',
  'dir.reports.rangeInvalid': 'Odaberite ispravne datume početka i završetka.',
  'dir.reports.rangeOrder': 'Datum završetka mora biti jednak datumu početka ili kasniji.',
  'dir.reports.rangeMax': 'Izvješća podržavaju maksimalan raspon datuma od 90 dana.',

  'adm.active': 'Aktivno',
  'adm.auto.action.add_tag': 'dodaj oznaku',
  'adm.auto.action.assign_agent': 'dodijeli agenta',
  'adm.auto.action.assign_group': 'dodijeli grupu',
  'adm.auto.action.send_email': 'pošalji e-poštu',
  'adm.auto.action.send_notification': 'pošalji obavijest',
  'adm.auto.action.set_priority': 'postavi prioritet',
  'adm.auto.action.set_status': 'postavi status',
  'adm.auto.actions': 'Radnje',
  'adm.auto.addAction': '+ Dodaj radnju',
  'adm.auto.addCondition': '+ Dodaj uvjet',
  'adm.auto.addRule': 'Dodaj pravilo',
  'adm.auto.colApplied': 'Primijenjene radnje',
  'adm.auto.colDate': 'Datum',
  'adm.auto.colMatched': 'Podudaranje',
  'adm.auto.colSubject': 'Predmet',
  'adm.auto.colTicket': 'Karta',
  'adm.auto.conditions': 'Uvjeti',
  'adm.auto.confirmDesc': 'Ovo pravilo odmah će se prestati izvršavati i ne može se vratiti.',
  'adm.auto.confirmLabel': 'Izbriši pravilo',
  'adm.auto.confirmTitle': 'Izbrisati pravilo automatizacije?',
  'adm.auto.countMany': '{count} pravila automatizacije',
  'adm.auto.countOne': '{count} pravilo automatizacije',
  'adm.auto.create': 'Stvori',
  'adm.auto.createFirst': 'Stvorite svoje prvo pravilo automatizacije',
  'adm.auto.createFirstDesc': 'Koristite Dodaj pravilo za automatsko usmjeravanje, određivanje prioriteta ili obavještavanje.',
  'adm.auto.deleteFailed': 'Brisanje nije uspjelo',
  'adm.auto.description': 'Pravila se izvršavaju redom prema položaju. Uvjeti unutar pravila povezani su operatorom I.',
  'adm.auto.editRule': 'Uredi pravilo automatizacije',
  'adm.auto.execFailed': 'Učitavanje izvršenja nije uspjelo',
  'adm.auto.field.assigneeId': 'nositelj',
  'adm.auto.field.companyId': 'tvrtka',
  'adm.auto.field.groupId': 'grupa',
  'adm.auto.field.priority': 'prioritet',
  'adm.auto.field.requesterId': 'podnositelj',
  'adm.auto.field.source': 'izvor',
  'adm.auto.field.status': 'status',
  'adm.auto.field.subject': 'predmet',
  'adm.auto.field.ticketTypeId': 'vrsta karte',
  'adm.auto.hits': 'Pogoci',
  'adm.auto.loadFailed': 'Učitavanje pravila automatizacije nije uspjelo',
  'adm.auto.log': 'Zapisnik',
  'adm.auto.logTitle': 'Zapisnik izvršavanja — {name}',
  'adm.auto.moveDown': 'Pomakni dolje',
  'adm.auto.moveUp': 'Pomakni gore',
  'adm.auto.newRule': 'Novo pravilo automatizacije',
  'adm.auto.no': 'Ne',
  'adm.auto.noRuns': 'Još nema zabilježenih izvršavanja',
  'adm.auto.noRunsDesc': 'Izvršavanja će se ovdje prikazati čim ovo pravilo prvi put odgovara nekoj karti.',
  'adm.auto.op.contains': 'sadrži',
  'adm.auto.op.ends_with': 'završava s',
  'adm.auto.op.greater_than': 'veće od',
  'adm.auto.op.in': 'u',
  'adm.auto.op.is': 'je',
  'adm.auto.op.is_empty': 'je prazno',
  'adm.auto.op.is_not': 'nije',
  'adm.auto.op.is_not_empty': 'nije prazno',
  'adm.auto.op.less_than': 'manje od',
  'adm.auto.op.not_contains': 'ne sadrži',
  'adm.auto.op.not_in': 'nije u',
  'adm.auto.op.starts_with': 'počinje s',
  'adm.auto.reorderFailed': 'Promjena redoslijeda nije uspjela',
  'adm.auto.saveFailed': 'Spremanje nije uspjelo',
  'adm.auto.stopProcessing': 'Zaustavi obradu sljedećih pravila',
  'adm.auto.title': 'Pravila automatizacije',
  'adm.auto.toggleFailed': 'Prebacivanje nije uspjelo',
  'adm.auto.trigger': 'Okidač *',
  'adm.auto.trigger.ticket_creation': 'Stvaranje karte',
  'adm.auto.trigger.ticket_update': 'Ažuriranje karte',
  'adm.auto.trigger.time_trigger': 'Vremenski',
  'adm.auto.triggerCol': 'Okidač',
  'adm.auto.valuePlaceholder': 'Vrijednost',
  'adm.auto.yes': 'Da',
  'adm.close': 'Zatvori',
  'adm.deleting': 'Brisanje...',
  'adm.description': 'Opis',
  'adm.descriptionLabel': 'Opis',
  'adm.edit': 'Uredi',
  'adm.email.addChannel': 'Dodaj kanal',
  'adm.email.addTitle': 'Dodaj kanal e-pošte',
  'adm.email.colEmail': 'E-pošta',
  'adm.email.colReplyTo': 'Odgovori na',
  'adm.email.colSmtp': 'SMTP',
  'adm.email.confirmDesc': 'Ovaj kanal više neće biti dostupan za poštu podrške.',
  'adm.email.confirmLabel': 'Izbriši kanal',
  'adm.email.confirmTitle': 'Izbrisati kanal e-pošte?',
  'adm.email.countMany': '{count} kanala e-pošte',
  'adm.email.countOne': '{count} kanal e-pošte',
  'adm.email.create': 'Stvori',
  'adm.email.createFirst': 'Dodajte svoj prvi kanal e-pošte',
  'adm.email.createFirstDesc': 'Koristite Dodaj kanal za povezivanje adrese podrške kako bi odgovori stizali u ovaj centar.',
  'adm.email.default': 'Zadano',
  'adm.email.defaultChannel': 'Zadani kanal',
  'adm.email.deleteFailed': 'Brisanje nije uspjelo',
  'adm.email.description': 'Upravljajte dolaznim/odlaznim adresama e-pošte, SMTP konfiguracijom i postavkama adrese za odgovor.',
  'adm.email.editTitle': 'Uredi kanal e-pošte',
  'adm.email.emailAddress': 'Adresa e-pošte *',
  'adm.email.loadFailed': 'Učitavanje konfiguracija e-pošte nije uspjelo',
  'adm.email.outbound': 'Odlazni SMTP',
  'adm.email.replyTo': 'Adresa za odgovor',
  'adm.email.replyToPh': '(zadano je adresa e-pošte)',
  'adm.email.saveFailed': 'Spremanje nije uspjelo',
  'adm.email.sesGlobal': 'SES (globalno)',
  'adm.email.smtpHost': 'SMTP poslužitelj',
  'adm.email.smtpHostPh': 'npr. email-smtp.eu-central-1.amazonaws.com',
  'adm.email.smtpPassword': 'SMTP lozinka',
  'adm.email.smtpPort': 'SMTP priključak',
  'adm.email.smtpUser': 'SMTP korisnik',
  'adm.email.title': 'Kanali e-pošte',
  'adm.groups.aboutBody': 'Članovi određuju koji agenti prema zadanim postavkama vide karte ove grupe. Radno vrijeme određuje SLA vremena za karte usmjerene ovamo, a kontakt za eskalaciju dobiva obavijest uz nositelja kada karta prekorači SLA.',
  'adm.groups.aboutTitle': 'O ovoj grupi',
  'adm.groups.accountDefault': 'Zadano za račun',
  'adm.groups.activeAgentMany': '{count} aktivnih agenata',
  'adm.groups.activeAgentOne': '{count} aktivan agent',
  'adm.groups.activeAgents': 'Aktivni agenti',
  'adm.groups.addMember': 'Dodaj člana',
  'adm.groups.assignment': 'Dodjela',
  'adm.groups.autoAssign': 'Automatska dodjela',
  'adm.groups.autoAssignNote': 'Dodjela karata u ovom proizvodu uvijek je ručna - ne postoji kružno ni opterećenjem vođeno usmjeravanje. Ova sklopka to ne mijenja.',
  'adm.groups.businessHours': 'Radno vrijeme',
  'adm.groups.colGroup': 'Grupa',
  'adm.groups.confirmDesc': 'Karte i predlošci koji koriste ovu grupu moraju se prvo ponovno dodijeliti.',
  'adm.groups.confirmLabel': 'Izbriši grupu',
  'adm.groups.confirmTitle': 'Izbrisati „{name}“?',
  'adm.groups.createFirst': 'Stvorite svoju prvu grupu',
  'adm.groups.defaultHours': 'Zadano radno vrijeme',
  'adm.groups.editAria': 'Uredi {name}',
  'adm.groups.editGroup': 'Uredi grupu',
  'adm.groups.escalateHelp': 'Dodaje se kao primatelj obavijesti kada karta u ovoj grupi prekorači SLA.',
  'adm.groups.escalateTo': 'Eskaliraj na',
  'adm.groups.escalatesTo': 'Eskalira na',
  'adm.groups.escalatesToName': 'Eskalira na {name}',
  'adm.groups.escalationBody': 'Kada karta u ovoj grupi prekorači SLA, kontakt za eskalaciju dodaje se kao primatelj obavijesti uz nositelja i članove grupe.',
  'adm.groups.escalationTitle': 'Kontakt za eskalaciju',
  'adm.groups.hoursHelp': 'Koristi se za SLA izračune na kartama u ovoj grupi.',
  'adm.groups.manageAgents': 'Upravljanje agentima',
  'adm.groups.manageHours': 'Upravljanje radnim vremenom',
  'adm.groups.manual': 'Ručno',
  'adm.groups.manualBody': 'Dodjela je u ovom proizvodu ručna - ne postoji kružna ni opterećenjem vođena automatska dodjela. Sklopka „Automatska dodjela“ na grupi utječe samo na to hoće li nove karte u toj grupi prema zadanim postavkama ostati nedodijeljene ili se vratiti na postojeće pravilo usmjeravanja; agenti i dalje sami preuzimaju i predaju karte.',
  'adm.groups.manualTitle': 'Ručna dodjela',
  'adm.groups.memberMany': '{count} članova',
  'adm.groups.memberOne': '{count} član',
  'adm.groups.members': 'Članovi',
  'adm.groups.newGroup': 'Nova grupa',
  'adm.groups.noEscalation': 'Nema kontakta za eskalaciju',
  'adm.groups.noMatch': 'Nijedna grupa ne odgovara pretraživanju',
  'adm.groups.noMembers': 'Još nema članova',
  'adm.groups.noMembersDesc': 'Odaberite aktivnog agenta iznad i odaberite Dodaj člana.',
  'adm.groups.remove': 'Ukloni',
  'adm.groups.routing': 'Usmjeravanje',
  'adm.groups.routingMethod': 'Način usmjeravanja',
  'adm.groups.saved': 'Grupa je spremljena.',
  'adm.groups.searchAria': 'Pretraži grupe',
  'adm.groups.searchPlaceholder': 'Pretraži po imenu',
  'adm.groups.selectActiveAgent': 'Odaberite aktivnog agenta',
  'adm.groups.showing': 'Prikazano {start}-{end} od {total}',
  'adm.groups.subtitle': 'Grupe kontroliraju usmjeravanje i vidljivost karata. Dodijelite agente kao članove te odaberite raspored radnog vremena i kontakt za eskalaciju za svaku grupu.',
  'adm.groups.title': 'Grupe',
  'adm.groups.tryDifferent': 'Pokušajte s drugim nazivom grupe.',
  'adm.groups.unassigned': 'Nedodijeljeno',
  'adm.groups.useNew': 'Koristite Nova grupa za usmjeravanje karata skupu agenata.',
  'adm.groups.zero': '0 grupa',
  'adm.inactive': 'Neaktivno',
  'adm.jira.accepted': 'Veza je prihvaćena',
  'adm.jira.accountEmail': 'E-pošta Jira računa',
  'adm.jira.accountEmailLabel': 'E-pošta računa',
  'adm.jira.activeConn': 'Aktivna veza',
  'adm.jira.addConnection': 'Dodaj vezu',
  'adm.jira.addTitle': 'Dodaj Jira vezu',
  'adm.jira.added': 'Jira veza je dodana',
  'adm.jira.apiToken': 'API token',
  'adm.jira.clearSecret': 'Obriši spremljenu tajnu webhooka',
  'adm.jira.confirmDesc': 'Time se uklanjaju spremljena veza i njezine poveznice s kartama. Jira zadaci se ne brišu.',
  'adm.jira.confirmLabel': 'Izbriši vezu',
  'adm.jira.confirmTitle': 'Izbrisati {name}?',
  'adm.jira.connName': 'Naziv veze',
  'adm.jira.connNamePh': 'Engineering Jira',
  'adm.jira.connectedAs': 'Povezano kao {name}',
  'adm.jira.connectionDesk': 'Centar za veze',
  'adm.jira.default': 'Zadano',
  'adm.jira.defaultConn': 'Zadana veza',
  'adm.jira.defaultIssueType': 'Zadana vrsta zadatka',
  'adm.jira.defaultProjectKey': 'Zadani ključ projekta',
  'adm.jira.defaults': 'Zadane vrijednosti',
  'adm.jira.description': 'Povežite Jira stranice u vlasništvu računa kako bi agenti mogli povezivati zadatke i usklađivati status karata.',
  'adm.jira.editTitle': 'Uredi Jira vezu',
  'adm.jira.footer': 'Stvorite Jira webhook s krajnjom točkom prikazanom iznad, pretplatite se na događaje ažuriranja zadatka i koristite istu tajnu webhooka konfiguriranu ovdje.',
  'adm.jira.heading': 'Držite podršku i razvoj u istoj petlji',
  'adm.jira.intro': 'Vjerodajnice se na poslužitelju pohranjuju šifrirane i nikada se ne vraćaju na ovaj zaslon. Konfigurirajte tajnu webhooka kada Jira treba slati promjene statusa natrag u SuzukiDesk.',
  'adm.jira.no': 'Ne',
  'adm.jira.noConns': 'Još nema Jira veza',
  'adm.jira.noConnsDesc': 'Dodajte vezu kako bi Jira radnje bile dostupne iz detalja karte.',
  'adm.jira.noProject': 'Nema projekta',
  'adm.jira.pasteToken': 'Zalijepite token',
  'adm.jira.requestFailed': 'Jira zahtjev nije uspio. Pokušajte ponovo.',
  'adm.jira.savedToast': 'Jira veza je spremljena',
  'adm.jira.secretConfigured': 'Tajna je konfigurirana: {value}',
  'adm.jira.secretHint': 'Koristite istu tajnu pri stvaranju Jira webhooka.',
  'adm.jira.secretOptional': 'Neobavezno, najmanje 16 znakova',
  'adm.jira.siteUrl': 'URL Jira stranice',
  'adm.jira.siteUrlHint': 'Ne uključujte vjerodajnice u URL.',
  'adm.jira.syncFromJira': 'Jira status natrag u kartu',
  'adm.jira.syncSnapshot': 'Snimka povezanog zadatka',
  'adm.jira.syncToJira': 'Status karte u Jiru',
  'adm.jira.testConnection': 'Testiraj vezu',
  'adm.jira.testFailed': 'Test veze nije uspio',
  'adm.jira.title': 'Jira integracija',
  'adm.jira.tokenHintEdit': 'Ostavite prazno za zadržavanje trenutnog tokena.',
  'adm.jira.tokenHintNew': 'Pohranjuje se šifrirano; neće se ponovno prikazati.',
  'adm.jira.tokenMissing': 'API token nedostaje',
  'adm.jira.tokenStored': 'API token je pohranjen',
  'adm.jira.unchanged': '(nepromijenjeno ako je prazno)',
  'adm.jira.verified': 'Jira veza je potvrđena',
  'adm.jira.webhookEndpoint': 'Krajnja točka Jira webhooka',
  'adm.jira.webhookSecret': 'Tajna webhooka',
  'adm.jira.whatSyncs': 'Što se sinkronizira',
  'adm.jira.yes': 'Da',
  'adm.nameRequired': 'Ime *',
  'adm.nextPage': 'Sljedeća stranica',
  'adm.notif.aud.all': 'Zajedničko',
  'adm.notif.aud.customer': 'Klijent',
  'adm.notif.aud.internal': 'Interno',
  'adm.notif.audEmail': 'E-pošta: {audience}',
  'adm.notif.body': 'Tijelo poruke',
  'adm.notif.description': 'Prilagodite svaku publiku obavijesti bez upućivanja klijenata u interni radni prostor.',
  'adm.notif.discardDesc': 'Nespremljene promjene ovog predloška obavijesti bit će izgubljene ako promijenite predložak.',
  'adm.notif.discardLabel': 'Odbaci promjene',
  'adm.notif.discardTitle': 'Odbaciti nespremljene promjene?',
  'adm.notif.discarded': 'Nespremljene promjene su odbačene.',
  'adm.notif.event.automation_notification': 'Obavijest automatizacije',
  'adm.notif.event.group_member_added': 'Dodan u grupu',
  'adm.notif.event.mention': 'Spominjanje',
  'adm.notif.event.pending_input': 'Čeka se unos',
  'adm.notif.event.sla_breach': 'SLA prekoračen',
  'adm.notif.event.sla_escalation': 'SLA eskalacija',
  'adm.notif.event.sla_warning': 'SLA upozorenje',
  'adm.notif.event.ticket_assigned': 'Karta dodijeljena',
  'adm.notif.event.ticket_created': 'Karta stvorena',
  'adm.notif.event.ticket_first_response': 'Prvi odgovor',
  'adm.notif.event.ticket_group_assigned': 'Karta dodijeljena grupi',
  'adm.notif.event.ticket_note': 'Privatna bilješka',
  'adm.notif.event.ticket_public_note': 'Javna bilješka',
  'adm.notif.event.ticket_reply': 'Odgovor na kartu',
  'adm.notif.event.ticket_resolved': 'Karta riješena',
  'adm.notif.events': 'Događaji',
  'adm.notif.eventsHelp': 'Odaberite događaj i publiku primatelja.',
  'adm.notif.insertVar': 'Umetni {variable}',
  'adm.notif.linkNoteAgent': 'Varijabla poveznice prilagođena publici {variable} otvara radni prostor agenta za ovu e-poštu.',
  'adm.notif.linkNoteCustomer': 'Varijabla poveznice prilagođena publici {variable} otvara portal za klijente za ovu e-poštu.',
  'adm.notif.off': 'isključeno',
  'adm.notif.preview': 'Pregled',
  'adm.notif.previewNotice': 'Pregled je prikazan s probnim podacima.',
  'adm.notif.rendering': 'Prikazivanje…',
  'adm.notif.route.all': 'Koristi poveznicu karte prilagođenu primatelju za publiku isporuke.',
  'adm.notif.route.customer': 'Glavna radnja otvara kartu na portalu za klijente.',
  'adm.notif.route.internal': 'Glavna radnja otvara kartu u radnom prostoru agenta.',
  'adm.notif.sampleOnlyAgent': 'Samo probni podaci — glavna radnja vodi na rutu radnog prostora agenta.',
  'adm.notif.sampleOnlyCustomer': 'Samo probni podaci — glavna radnja vodi na rutu portala za klijente.',
  'adm.notif.saveChanges': 'Spremi promjene',
  'adm.notif.saved': 'Predložak je spremljen.',
  'adm.notif.savedBtn': 'Spremljeno',
  'adm.notif.selectEvent': 'Odaberite događaj za uređivanje njegovog predloška',
  'adm.notif.selectEventDesc': 'Odaberite događaj obavijesti s lijeve strane za promjenu predmeta i tijela poruke.',
  'adm.notif.sendTest': 'Pošalji probnu e-poštu',
  'adm.notif.sending': 'Slanje…',
  'adm.notif.subject': 'Predmet',
  'adm.notif.testQueued': 'Probna e-pošta stavljena je u red za {email}.',
  'adm.notif.title': 'Predlošci obavijesti',
  'adm.notif.urlVarTitle': 'Varijabla poveznice prilagođena publici',
  'adm.notif.useTemplate': 'Koristi ovaj predložak za ovu publiku',
  'adm.notif.useTemplateHelp': 'Isključivanjem se koristi sigurna zamjenska obavijest.',
  'adm.notif.variables': 'Varijable',
  'adm.notif.variablesHelp': 'Kliknite za dodavanje u tijelo poruke',
  'adm.pagination': 'Straničenje',
  'adm.perm.cap.admin.label': 'Pristup administratorskoj konzoli',
  'adm.perm.cap.assign.label': 'Dodjela karte',
  'adm.perm.cap.close.label': 'Zatvaranje karte',
  'adm.perm.cap.conversation_delete.label': 'Brisanje objavljenog odgovora ili bilješke',
  'adm.perm.cap.conversation_edit.label': 'Uređivanje objavljenog odgovora ili bilješke',
  'adm.perm.cap.create.label': 'Stvaranje karte',
  'adm.perm.cap.delete.label': 'Brisanje karte',
  'adm.perm.cap.edit.label': 'Uređivanje svojstava karte',
  'adm.perm.cap.export.label': 'Izvoz karata',
  'adm.perm.cap.field_admin.label': 'Polja zahtjeva',
  'adm.perm.cap.form_admin.label': 'Obrasci zahtjeva',
  'adm.perm.cap.forward.label': 'Prosljeđivanje karte',
  'adm.perm.cap.jira_link.label': 'Povezivanje i upravljanje Jira zadacima',
  'adm.perm.cap.kb.label': 'Pristup bazi znanja',
  'adm.perm.cap.manage_agents.label': 'Agenti',
  'adm.perm.cap.manage_api_keys.label': 'API ključevi',
  'adm.perm.cap.manage_automations.label': 'Automatizacije',
  'adm.perm.cap.manage_canned_responses.label': 'Spremljeni odgovori',
  'adm.perm.cap.manage_email_config.label': 'E-pošta',
  'adm.perm.cap.manage_groups.label': 'Grupe',
  'adm.perm.cap.manage_jira.label': 'Jira integracija',
  'adm.perm.cap.manage_kb.label': 'Baza znanja',
  'adm.perm.cap.manage_notification_templates.label': 'Predlošci obavijesti',
  'adm.perm.cap.manage_roles.label': 'Uloge',
  'adm.perm.cap.manage_tags.label': 'Oznake',
  'adm.perm.cap.note.label': 'Dodavanje ili uređivanje privatnih bilješki',
  'adm.perm.cap.reassign.label': 'Ponovna dodjela karte koju već posjeduje netko drugi',
  'adm.perm.cap.reopen.label': 'Ponovno otvaranje riješene ili zatvorene karte',
  'adm.perm.cap.reply.label': 'Javni odgovor klijentu',
  'adm.perm.cap.report_access.label': 'Pregled izvješća i nadzornih ploča',
  'adm.perm.cap.reports.label': 'Pristup modulu izvješćivanja',
  'adm.perm.cap.resolve.label': 'Rješavanje karte',
  'adm.perm.cap.settings_admin.label': 'Otvaranje odjeljka Postavke (potrebno za prikaz stavke izbornika Postavke i njezine početne stranice; pristup svakoj stranici ispod i dalje se kontrolira zasebno)',
  'adm.perm.cap.sla_admin.label': 'SLA pravila i radno vrijeme',
  'adm.perm.cap.sla_edit.desc': 'Odvojeno od dopuštenja Postavke > SLA pravila ispod — ovo pokriva samo uređivanje rokova na pojedinačnoj karti.',
  'adm.perm.cap.sla_edit.label': 'Ručno nadjačavanje SLA rokova karte',
  'adm.perm.cap.tag.label': 'Upravljanje oznakama karata',
  'adm.perm.cap.thread_start.label': 'Pokretanje privatne niti na unosu razgovora',
  'adm.perm.cap.tickets.label': 'Pristup radnom prostoru karata',
  'adm.perm.cap.view.label': 'Pregled karata u dosegu',
  'adm.perm.cat.administration.desc': 'Pristup administratorskoj konzoli i njezinim zaslonima konfiguracije.',
  'adm.perm.cat.administration.label': 'Administracija',
  'adm.perm.cat.knowledge.desc': 'Čitanje i korištenje sadržaja znanja tijekom rada na karti.',
  'adm.perm.cat.knowledge.label': 'Baza znanja',
  'adm.perm.cat.reporting.desc': 'Operativno izvješćivanje i nadzorne ploče.',
  'adm.perm.cat.reporting.label': 'Izvješćivanje',
  'adm.perm.cat.settings-pages.desc': 'Odobrite pristup svakom zaslonu Postavki zasebno. Ništa nije vidljivo dok se ovdje izričito ne označi.',
  'adm.perm.cat.settings-pages.label': 'Stranice postavki',
  'adm.perm.cat.tickets.desc': 'Što agent može raditi unutar radnog prostora karata.',
  'adm.perm.cat.tickets.label': 'Karte',
  'adm.previousPage': 'Prethodna stranica',
  'adm.refresh': 'Osvježi',
  'adm.roleType.administrator': 'Administrator',
  'adm.roleType.agent': 'Agent',
  'adm.roleType.collaborator': 'Suradnik',
  'adm.roleType.customer': 'Klijent',
  'adm.roleType.super_admin': 'Superadministrator',
  'adm.roleType.supervisor': 'Supervizor',
  'adm.roles.activeHelp': 'Aktivno - neaktivne uloge ne mogu se dodijeliti agentima',
  'adm.roles.agentCan': 'Agent može',
  'adm.roles.agentType': 'Vrsta agenta',
  'adm.roles.agentsAssignedNote': 'Agentima se ova uloga dodjeljuje na zaslonu Agenti.',
  'adm.roles.agentsCount': 'Agenata: {count}',
  'adm.roles.agentsLabel': 'Agenti',
  'adm.roles.agentsManage': 'Agenata: {count} - Upravljanje',
  'adm.roles.builtIn': '(Ugrađeno)',
  'adm.roles.builtInNote': 'Ovo je ugrađena uloga. Može se preimenovati i deaktivirati, ali ne i izbrisati.',
  'adm.roles.builtInTitle': 'Ugrađena uloga: može se uređivati i deaktivirati, ali ne i izbrisati',
  'adm.roles.categoriesAria': 'Kategorije dopuštenja',
  'adm.roles.confirmDesc': 'Agentima dodijeljenima ovoj ulozi treba druga uloga prije nego što se ona može ukloniti.',
  'adm.roles.confirmLabel': 'Izbriši ulogu',
  'adm.roles.createFirst': 'Stvorite svoju prvu ulogu',
  'adm.roles.createFirstDesc': 'Koristite Nova uloga za definiranje mogućnosti koje agenti trebaju dobiti.',
  'adm.roles.editRole': 'Uredi ulogu',
  'adm.roles.granted': 'Odobreno: {count}',
  'adm.roles.heading': 'Uloge agenata',
  'adm.roles.inactive': 'Neaktivno',
  'adm.roles.newRole': 'Nova uloga',
  'adm.roles.noAgent': 'Nema agenta',
  'adm.roles.notEnforced': '(još se ne provodi)',
  'adm.roles.notEnforcedTitle': 'Pohranjeno na ulozi, ali se za sada nigdje ne provjerava tijekom izvođenja',
  'adm.roles.permissions': 'Dopuštenja',
  'adm.roles.saved': 'Uloga je spremljena.',
  'adm.roles.scopeBody': 'Mogućnosti se kombiniraju s dosegom na razini retka (sve / grupa / dodijeljeno / vlastito), pa agent uvijek djeluje samo na kartama koje već može vidjeti.',
  'adm.roles.scopeTitle': 'Doseg i dalje vrijedi',
  'adm.roles.scrollTo': 'Pomakni na',
  'adm.roles.status': 'Status',
  'adm.roles.subtitle': 'Odredite i ograničite detaljne razine pristupa i ovlasti za agente.',
  'adm.roles.title': 'Uloge',
  'adm.roles.typeLocked': 'Vrsta agenta ne može se promijeniti nakon spremanja uloge.',
  'adm.roles.understandingBody1': 'Uloge određuju što agent može raditi. Stvorite ulogu, označite mogućnosti koje treba dodijeliti, a zatim je dodijelite agentima na zaslonu Agenti.',
  'adm.roles.understandingBody2': 'Ugrađene uloge mogu se preimenovati i deaktivirati, ali nikada izbrisati. Uloga kojoj su još dodijeljeni agenti također se ne može izbrisati, pa prvo premjestite te agente.',
  'adm.roles.understandingTitle': 'Razumijevanje uloga',
  'adm.saveChanges': 'Spremi promjene',
  'adm.settings.add': 'Dodaj: {name}',
  'adm.settings.back': 'Natrag na postavke',
  'adm.settings.cannedDesc': 'Odgovori računa dostupni vam tijekom rada na karti.',
  'adm.settings.cannedEmpty': 'Još nema spremljenih odgovora',
  'adm.settings.cannedEmptyDesc': 'Zamolite administratora da doda zajedničke odgovore koje vaš tim može ponovno koristiti na karti.',
  'adm.settings.cannedTitle': 'Spremljeni odgovori',
  'adm.settings.col.autoAssign': 'Automatska dodjela',
  'adm.settings.col.color': 'Boja',
  'adm.settings.col.content': 'Sadržaj',
  'adm.settings.col.createdAt': 'Stvoreno',
  'adm.settings.col.description': 'Opis',
  'adm.settings.col.email': 'E-pošta',
  'adm.settings.col.expiresAt': 'Istječe',
  'adm.settings.col.fieldType': 'Vrsta polja',
  'adm.settings.col.firstName': 'Ime',
  'adm.settings.col.folderId': 'ID mape',
  'adm.settings.col.hitCount': 'Broj pogodaka',
  'adm.settings.col.holidays': 'Praznici',
  'adm.settings.col.host': 'Poslužitelj',
  'adm.settings.col.hours': 'Sati',
  'adm.settings.col.id': 'ID',
  'adm.settings.col.isActive': 'Aktivno',
  'adm.settings.col.isBuiltIn': 'Ugrađeno',
  'adm.settings.col.isDefault': 'Zadano',
  'adm.settings.col.isRequired': 'Obavezno',
  'adm.settings.col.isShared': 'Zajedničko',
  'adm.settings.col.isSystem': 'Sustavno',
  'adm.settings.col.key': 'Ključ',
  'adm.settings.col.label': 'Oznaka',
  'adm.settings.col.language': 'Jezik',
  'adm.settings.col.lastName': 'Prezime',
  'adm.settings.col.lastUsedAt': 'Zadnje korišteno',
  'adm.settings.col.name': 'Naziv',
  'adm.settings.col.options': 'Opcije',
  'adm.settings.col.phone': 'Telefon',
  'adm.settings.col.port': 'Priključak',
  'adm.settings.col.position': 'Položaj',
  'adm.settings.col.prefix': 'Prefiks',
  'adm.settings.col.priority': 'Prioritet',
  'adm.settings.col.required': 'Obavezno',
  'adm.settings.col.role': 'Uloga',
  'adm.settings.col.roleId': 'ID uloge',
  'adm.settings.col.scopes': 'Dosezi',
  'adm.settings.col.slug': 'Slug',
  'adm.settings.col.status': 'Status',
  'adm.settings.col.stopProcessing': 'Zaustavi obradu',
  'adm.settings.col.timezone': 'Vremenska zona',
  'adm.settings.col.title': 'Naslov',
  'adm.settings.col.trigger': 'Okidač',
  'adm.settings.col.type': 'Vrsta',
  'adm.settings.col.updatedAt': 'Ažurirano',
  'adm.settings.col.usageCount': 'Broj korištenja',
  'adm.settings.col.username': 'Korisničko ime',
  'adm.settings.confirmDesc': 'Ovo se ne može poništiti.',
  'adm.settings.confirmTitle': 'Izbrisati {name}?',
  'adm.settings.count': '{count} {title}',
  'adm.settings.create': 'Stvori',
  'adm.settings.empty': 'Još nema stavki: {title}',
  'adm.settings.emptyAdd': 'Koristite obrazac iznad za dodavanje svog prvog unosa: {name}.',
  'adm.settings.emptyOther': 'Unosi će se ovdje prikazati nakon što se konfiguriraju.',
  'adm.settings.homeDesc': 'Konfigurirajte korisnike, tijekove rada karata, razine usluge i integracije.',
  'adm.settings.manage': 'Upravljanje: {title}.',
  'adm.settings.noPages': 'Nema dostupnih stranica postavki',
  'adm.settings.noPagesDesc': 'Zamolite superadministratora da odobri pristup stranicama postavki koje trebate.',
  'adm.settings.notFound': 'Stranica postavki nije pronađena',
  'adm.settings.notFoundDesc': 'Odaberite područje postavki za nastavak.',
  'adm.settings.res.agents.field.email': 'E-pošta',
  'adm.settings.res.agents.field.firstName': 'Ime',
  'adm.settings.res.agents.field.lastName': 'Prezime',
  'adm.settings.res.agents.field.password': 'Privremena lozinka',
  'adm.settings.res.agents.field.roleId': 'ID uloge',
  'adm.settings.res.agents.one': 'agent',
  'adm.settings.res.agents.title': 'Agenti',
  'adm.settings.res.api-keys.field.name': 'Naziv ključa',
  'adm.settings.res.api-keys.one': 'API ključ',
  'adm.settings.res.api-keys.title': 'API ključevi',
  'adm.settings.res.automations.field.description': 'Opis',
  'adm.settings.res.automations.field.name': 'Naziv',
  'adm.settings.res.automations.one': 'automatizacija',
  'adm.settings.res.automations.title': 'Automatizacije',
  'adm.settings.res.business-hours.field.name': 'Naziv',
  'adm.settings.res.business-hours.field.timezone': 'Vremenska zona',
  'adm.settings.res.business-hours.one': 'unos radnog vremena',
  'adm.settings.res.business-hours.title': 'Radno vrijeme',
  'adm.settings.res.canned-responses.field.content': 'Sadržaj odgovora',
  'adm.settings.res.canned-responses.field.title': 'Naslov',
  'adm.settings.res.canned-responses.one': 'spremljeni odgovor',
  'adm.settings.res.canned-responses.title': 'Spremljeni odgovori',
  'adm.settings.res.email.field.host': 'SMTP poslužitelj',
  'adm.settings.res.email.field.name': 'Naziv',
  'adm.settings.res.email.field.port': 'SMTP priključak',
  'adm.settings.res.email.field.username': 'Korisničko ime',
  'adm.settings.res.email.one': 'konfiguracija e-pošte',
  'adm.settings.res.email.title': 'Konfiguracija e-pošte',
  'adm.settings.res.fields.one': 'polje zahtjeva',
  'adm.settings.res.fields.title': 'Polja zahtjeva',
  'adm.settings.res.forms.field.label': 'Prikazana oznaka',
  'adm.settings.res.forms.field.name': 'Naziv polja',
  'adm.settings.res.forms.field.type': 'Vrsta polja',
  'adm.settings.res.forms.one': 'obrazac ili prilagođeno polje',
  'adm.settings.res.forms.title': 'Obrasci i prilagođena polja',
  'adm.settings.res.groups.field.description': 'Opis',
  'adm.settings.res.groups.field.name': 'Naziv',
  'adm.settings.res.groups.one': 'grupa',
  'adm.settings.res.groups.title': 'Grupe',
  'adm.settings.res.jira.one': 'Jira integracija',
  'adm.settings.res.jira.title': 'Jira integracija',
  'adm.settings.res.kb.field.content': 'Sadržaj članka',
  'adm.settings.res.kb.field.folderId': 'ID mape',
  'adm.settings.res.kb.field.title': 'Naslov članka',
  'adm.settings.res.kb.one': 'članak baze znanja',
  'adm.settings.res.kb.title': 'Administracija baze znanja',
  'adm.settings.res.notification-templates.one': 'predložak obavijesti',
  'adm.settings.res.notification-templates.title': 'Predlošci obavijesti',
  'adm.settings.res.roles.field.description': 'Opis',
  'adm.settings.res.roles.field.name': 'Naziv',
  'adm.settings.res.roles.field.type': 'Vrsta uloge',
  'adm.settings.res.roles.one': 'uloga',
  'adm.settings.res.roles.title': 'Uloge',
  'adm.settings.res.sla.field.description': 'Opis',
  'adm.settings.res.sla.field.name': 'Naziv',
  'adm.settings.res.sla.one': 'SLA pravilo',
  'adm.settings.res.sla.title': 'SLA pravila',
  'adm.settings.res.tags.field.name': 'Naziv',
  'adm.settings.res.tags.one': 'oznaka',
  'adm.settings.res.tags.title': 'Oznake',
  'adm.settings.title': 'Postavke',
  'adm.status': 'Status',

  'sla.edit': 'Uredi',
  'sla.active': 'Aktivno',
  'sla.inactive': 'Neaktivno',
  'sla.default': 'Zadano',
  'sla.yes': 'Da',
  'sla.no': 'Ne',
  'sla.description': 'Opis',
  'sla.status': 'Status',
  'sla.notConfigured': 'Nije konfigurirano',
  'sla.minutesValue': '{value} min',
  'sla.invalidServerValue': 'Neispravna vrijednost poslužitelja',
  'sla.statusSemantics.title': 'Semantika statusa karte',
  'sla.statusSemantics.description': 'Svaki aktivni status ima izričit SLA ugovor. Status koji pauzira i status koji zaustavlja SLA međusobno se isključuju.',
  'sla.statusSemantics.conflict': 'Status ne može istodobno pauzirati i zaustaviti SLA.',
  'sla.statusSemantics.emptyTitle': 'Nema definicija statusa',
  'sla.statusSemantics.emptyDescription': 'Definicije statusa prikazat će se ovdje nakon konfiguriranja za ovaj račun.',
  'sla.statusSemantics.colPauses': 'Pauzira SLA',
  'sla.statusSemantics.colStops': 'Zaustavlja SLA',
  'sla.statusSemantics.pausesAria': '{label} pauzira SLA',
  'sla.statusSemantics.stopsAria': '{label} zaustavlja SLA',
  'sla.preview.title': 'Pregled karte samo za čitanje',
  'sla.preview.description': 'Pokrenite isti evaluator na razini računa koji se koristi za žive SLA cikluse. Ovaj pregled nikada ne zapisuje pravilo ni kartu.',
  'sla.preview.priority': 'Prioritet',
  'sla.preview.group': 'Grupa',
  'sla.preview.anyGroup': 'Bilo koja grupa',
  'sla.preview.company': 'Tvrtka',
  'sla.preview.anyCompany': 'Bilo koja tvrtka',
  'sla.preview.source': 'Izvor',
  'sla.preview.anySource': 'Bilo koji izvor',
  'sla.preview.ticketType': 'Vrsta karte',
  'sla.preview.anyTicketType': 'Bilo koja vrsta karte',
  'sla.preview.representativeStart': 'Reprezentativni početak',
  'sla.preview.calculating': 'Izračun…',
  'sla.preview.run': 'Pokreni pregled',
  'sla.preview.configAttention': 'Konfiguracija zahtijeva pozornost',
  'sla.preview.selectedPolicy': 'Odabrano pravilo',
  'sla.preview.noPolicy': 'Nema pravila',
  'sla.preview.evaluationOrder': 'Redoslijed evaluacije',
  'sla.preview.firstMatching': 'Prvo odgovarajuće pravilo',
  'sla.preview.calculationMode': 'Način izračuna',
  'sla.preview.modeBusinessHours': 'Radno vrijeme',
  'sla.preview.modeBusinessHoursNamed': 'Radno vrijeme · {name}',
  'sla.preview.mode247': '24/7 proteklo vrijeme',
  'sla.preview.modeNone': 'Nije izračunato',
  'sla.preview.thresholds': 'Neovisni pragovi',
  'sla.preview.colMetric': 'Metrika',
  'sla.preview.colTarget': 'Cilj',
  'sla.preview.colWarning': 'Upozorenje',
  'sla.preview.colDue': 'Rok / prekoračenje',
  'sla.preview.colEscalation': 'Eskalacija',
  'sla.preview.colState': 'Stanje',
  'sla.preview.metricFirstResponse': 'Prvi odgovor',
  'sla.preview.metricResolution': 'Rješavanje',
  'sla.preview.trace': 'Trag evaluacije pravila',
  'sla.preview.selected': 'Odabrano',
  'sla.preview.matchedAfterSelection': 'Podudara se nakon odabira',
  'sla.preview.skipped': 'Preskočeno',
  'sla.preview.showTrace': 'Prikaži trag izračuna',
  'sla.state.not_configured': 'nije konfigurirano',
  'sla.state.running': 'u tijeku',
  'sla.state.paused': 'pauzirano',
  'sla.state.warning': 'upozorenje',
  'sla.state.breached': 'prekoračeno',
  'sla.state.met': 'ispunjeno',
  'sla.state.escalated': 'eskalirano',
  'sla.state.pending': 'na čekanju',
  'sla.state.stopped': 'zaustavljeno',
  'sla.state.on_track': 'u skladu s planom',
  'sla.state.at_risk': 'u riziku',
  'sla.list.subtitle': 'Postavite ciljeve prvog odgovora i rješavanja po prioritetu. Pravila se evaluiraju od vrha prema dnu — pobjeđuje prvo čiji se uvjeti podudaraju s kartom.',
  'sla.list.newPolicy': 'Novo pravilo',
  'sla.list.emptyTitle': 'Stvorite svoje prvo SLA pravilo',
  'sla.list.emptyDescription': 'Koristite Novo pravilo za postavljanje ciljeva prvog odgovora i rješavanja po prioritetu.',
  'sla.list.moveUp': 'Pomakni gore',
  'sla.list.moveDown': 'Pomakni dolje',
  'sla.list.frShort': 'PO: {value}',
  'sla.list.resolveShort': 'Rješavanje: {value}',
  'sla.list.escalateShort': 'Eskalacija: +{value}',
  'sla.list.deactivate': 'Deaktiviraj',
  'sla.list.activate': 'Aktiviraj',
  'sla.list.setDefault': 'Postavi kao zadano',
  'sla.list.duplicate': 'Dupliciraj',
  'sla.list.deleteTitle': 'Izbrisati „{name}“?',
  'sla.list.deleteDescription': 'Karte povezane s ovim pravilom koristit će sljedeće dostupno SLA pravilo.',
  'sla.list.deleteConfirm': 'Izbriši pravilo',
  'sla.conditions.groups': 'grupa: {count}',
  'sla.conditions.companies': 'tvrtki: {count}',
  'sla.conditions.sources': 'izvori: {list}',
  'sla.conditions.ticketTypes': 'vrsta karata: {count}',
  'sla.conditions.anyOf': 'bilo koji od',
  'sla.conditions.allOf': 'svi od',
  'sla.conditions.summary': 'Uvjeti ({mode}): {parts}',
  'sla.edit.newTitle': 'Novo SLA pravilo',
  'sla.edit.editTitle': 'Uredi SLA pravilo',
  'sla.edit.saved': 'SLA pravilo je spremljeno.',
  'sla.edit.name': 'Naziv',
  'sla.edit.appliesToPriority': 'Vrijedi za prioritet',
  'sla.edit.evaluationOrder': 'Redoslijed evaluacije',
  'sla.edit.evaluationOrderHint': 'Niži položaji evaluiraju se prvi za ovaj račun.',
  'sla.edit.defaultPolicy': 'Zadano pravilo',
  'sla.edit.useAsDefault': 'Koristi kao zadano kada nijedno drugo pravilo ne odgovara',
  'sla.edit.targets': 'SLA ciljevi',
  'sla.edit.firstResponse': 'Prvi odgovor',
  'sla.edit.resolution': 'Rješavanje',
  'sla.edit.autoAt75': 'Automatski na 75%',
  'sla.edit.enabledAfter': 'Uključeno nakon {value}',
  'sla.edit.clearEscalation': 'Izričito obriši cilj eskalacije',
  'sla.edit.clearEscalationHint': 'Šalje null; ako ovo ostane neoznačeno, polje se izostavlja i čuva se spremljena vrijednost.',
  'sla.edit.firstResponseMinutes': 'Prvi odgovor (minute)',
  'sla.edit.resolutionMinutes': 'Rješavanje (minute)',
  'sla.edit.escalateAfter': 'Eskaliraj nakon (minuta nakon roka rješavanja)',
  'sla.edit.notSet': 'Nije postavljeno',
  'sla.edit.remindersNote': 'Podsjetnici se automatski aktiviraju na 75% prozora prvog odgovora i rješavanja. Eskalacija obavještava agenta za eskalaciju grupe karte (postavljenog na grupi) nakon što je cilj rješavanja propušten za konfigurirani broj minuta.',
  'sla.edit.conditions': 'Uvjeti',
  'sla.edit.conditionsHint': 'Ostavite grupu neoznačenom da bi se podudarale sve vrijednosti',
  'sla.edit.matchMode': 'Način podudaranja:',
  'sla.edit.matchAll': 'Podudaraju se SVI uvjeti',
  'sla.edit.matchAny': 'Podudara se BILO KOJI uvjet',
  'sla.edit.groups': 'Grupe',
  'sla.edit.companies': 'Tvrtke',
  'sla.edit.sources': 'Izvori',
  'sla.edit.ticketTypes': 'Vrste karata',
  'sla.bh.subtitle': 'Definirajte tjedni raspored i kalendar praznika koje SLA pravila koriste za izračun rokova.',
  'sla.bh.newCalendar': 'Novi kalendar',
  'sla.bh.emptyTitle': 'Stvorite svoj prvi kalendar radnog vremena',
  'sla.bh.emptyDescription': 'Koristite Novi kalendar za definiranje tjednog rasporeda prema kojem SLA pravila računaju.',
  'sla.bh.accountDefault': 'Zadano za račun',
  'sla.bh.closedEveryDay': 'Zatvoreno svaki dan',
  'sla.bh.openEveryDay': 'Otvoreno svaki dan',
  'sla.bh.openDaysOne': 'Otvoreno 1 dan tjedno',
  'sla.bh.openDaysMany': 'Otvoreno dana tjedno: {count}',
  'sla.bh.holidayOne': '1 praznik',
  'sla.bh.holidayMany': 'praznika: {count}',
  'sla.bh.deleteTitle': 'Izbrisati „{name}“?',
  'sla.bh.deleteDescription': 'SLA pravila i grupe koji koriste ovaj raspored vratit će se na zadano za račun.',
  'sla.bh.deleteConfirm': 'Izbriši raspored',
  'sla.bh.newTitle': 'Novi kalendar radnog vremena',
  'sla.bh.editTitle': 'Uredi radno vrijeme',
  'sla.bh.saved': 'Radno vrijeme je spremljeno.',
  'sla.bh.timezone': 'Vremenska zona',
  'sla.bh.defaultCalendar': 'Zadani kalendar',
  'sla.bh.useAsDefault': 'Koristi za SLA pravila i grupe koje ne navode vlastiti kalendar',
  'sla.bh.weeklySchedule': 'Tjedni raspored',
  'sla.bh.colDay': 'Dan',
  'sla.bh.colOpen': 'Otvoreno',
  'sla.bh.colStart': 'Početak',
  'sla.bh.colEnd': 'Kraj',
  'sla.bh.dayOpenAria': '{day} otvoreno',
  'sla.bh.dayStartAria': '{day} vrijeme početka',
  'sla.bh.dayEndAria': '{day} vrijeme završetka',
  'sla.bh.holidayCalendar': 'Kalendar praznika',
  'sla.bh.saveFirst': 'Prvo spremite ovaj kalendar, zatim dodajte praznike.',
  'sla.bh.holidayName': 'Naziv praznika',
  'sla.bh.date': 'Datum',
  'sla.bh.addHoliday': 'Dodaj praznik',
  'sla.bh.noHolidays': 'Još nema praznika',
  'sla.bh.noHolidaysHint': 'Dodajte praznik s datumom iznad kako biste ga isključili iz SLA izračuna.',
  'sla.bh.remove': 'Ukloni',
  'sla.day.monday': 'Ponedjeljak',
  'sla.day.tuesday': 'Utorak',
  'sla.day.wednesday': 'Srijeda',
  'sla.day.thursday': 'Četvrtak',
  'sla.day.friday': 'Petak',
  'sla.day.saturday': 'Subota',
  'sla.day.sunday': 'Nedjelja',

  'set.ftype.single_line_text': 'Jednoredni tekst',
  'set.ftype.multi_line_text': 'Višeredni tekst',
  'set.ftype.dropdown': 'Padajući popis',
  'set.ftype.checkbox': 'Potvrdni okvir',
  'set.ftype.radio': 'Izborni gumb',
  'set.ftype.multiselect': 'Višestruki odabir',
  'set.ftype.lookup': 'Veza pretraživanja',
  'set.ftype.dependent': 'Ovisno polje',
  'set.ftype.date': 'Datum',
  'set.ftype.number': 'Broj',
  'set.ftype.decimal': 'Decimalni broj',
  'set.ftype.desc.lookup': 'Odaberite zapis iz sistemskog izvora.',
  'set.ftype.desc.single_line_text': 'Kratka tekstualna vrijednost.',
  'set.ftype.desc.multi_line_text': 'Dugačka tekstualna vrijednost.',
  'set.ftype.desc.checkbox': 'Vrijednost točno ili netočno.',
  'set.ftype.desc.dropdown': 'Odaberite jednu normaliziranu opciju.',
  'set.ftype.desc.dependent': 'Opcije ovise o nadređenom polju.',
  'set.ftype.desc.date': 'Vrijednost kalendarskog datuma.',
  'set.ftype.desc.number': 'Vrijednost cijelog broja.',
  'set.ftype.desc.decimal': 'Vrijednost decimalnog broja.',
  'set.src.STATIC': 'Statične opcije',
  'set.src.AGENTS': 'Agenti',
  'set.src.USERS': 'Korisnici / klijenti',
  'set.src.GROUPS': 'Grupe',
  'set.src.ROLE': 'Uloge',
  'set.src.COUNTRIES': 'Države',
  'set.src.CUSTOM': 'Prilagođeni padajući popis',
  'set.settings': 'Postavke',
  'set.ticketFields': 'Polja zahtjeva',
  'set.ticketForms': 'Obrasci zahtjeva',
  'set.requestFailed': 'Zahtjev nije uspio. Pokušajte ponovo.',
  'set.refresh': 'Osvježi',
  'set.saving': 'Spremanje…',
  'set.saveChanges': 'Spremi promjene',
  'set.default': 'Zadano',
  'set.published': 'Objavljeno',
  'set.draft': 'Skica',
  'set.publish': 'Objavi',
  'set.unpublish': 'Povuci objavu',
  'set.deleteForm': 'Izbriši obrazac',
  'set.description': 'Opis',
  'set.relationshipSource': 'Izvor veze',
  'set.dependsOn': 'Ovisi o: {field}',
  'set.deleteFormTitle': 'Izbrisati „{name}“?',
  'set.deleteFormDescription': 'Ovaj obrazac zahtjeva i njegova konfiguracija bit će trajno izbrisani.',
  'set.formIdRequired': 'ID obrasca je obavezan.',
  'set.formNotFound': 'Obrazac zahtjeva nije pronađen.',
  'set.tf.removeOption': 'Ukloni {label}',
  'set.tf.noOptions': 'Opcije još nisu definirane.',
  'set.tf.addOptionPlaceholder': 'Dodaj opciju...',
  'set.tf.add': 'Dodaj',
  'set.tf.dependsOnField': 'Ovisi o polju',
  'set.tf.selectParent': '— Odaberite nadređeno polje —',
  'set.tf.parentHelp': 'Nadređeno polje padajućeg popisa čija odabrana vrijednost određuje dostupne opcije ovog polja.',
  'set.tf.optionMappings': 'Mapiranja opcija',
  'set.tf.savingParen': '(spremanje...)',
  'set.tf.mappingsError': 'Nije moguće učitati mapiranja',
  'set.tf.archivedParen': ' (arhivirano)',
  'set.tf.mappedCount': 'mapirano: {count}',
  'set.tf.saveFirst': 'Prvo spremite polje da biste konfigurirali mapiranja opcija.',
  'set.tf.newField': 'Novo: {type}',
  'set.tf.pageDescription': 'Upravljajte uvezenim definicijama polja, vidljivošću, pravilima obaveznosti i redoslijedom koji koriste obrasci zahtjeva.',
  'set.tf.addField': 'Dodaj polje',
  'set.tf.addFieldHelp': 'Povucite vrstu na popis polja ili koristite Dodaj.',
  'set.tf.addType': 'Dodaj: {type}',
  'set.tf.registry': 'Registar polja',
  'set.tf.savingOrder': 'Spremanje redoslijeda…',
  'set.tf.searchAria': 'Pretraži polja zahtjeva',
  'set.tf.searchPlaceholder': 'Pretraži po nazivu ili ključu...',
  'set.tf.filterAria': 'Filtriraj po vrsti polja',
  'set.tf.allTypes': 'Sve vrste polja',
  'set.tf.emptyFirstTitle': 'Dodajte svoje prvo polje zahtjeva',
  'set.tf.emptyFirstDesc': 'Povucite vrstu polja iz palete ili koristite Dodaj za stvaranje.',
  'set.tf.emptyFilterTitle': 'Nijedno polje ne odgovara ovim filtrima',
  'set.tf.emptyFilterDesc': 'Pokušajte s drugim izrazom pretraživanja ili proširite filtar vrste polja.',
  'set.tf.archived': 'Arhivirano',
  'set.tf.dependent': 'Ovisno',
  'set.tf.customerVisible': 'Vidljivo klijentu',
  'set.tf.internal': 'Interno',
  'set.tf.configuration': 'Konfiguracija polja',
  'set.tf.selectTitle': 'Odaberite polje za konfiguriranje',
  'set.tf.selectDesc': 'Odaberite polje iz registra za uređivanje njegovih oznaka, pravila i vidljivosti.',
  'set.tf.externalId': 'Vanjski ID: {value}',
  'set.tf.sourceRenderer': 'Izvor: {source} · Prikazivač: {renderer}',
  'set.tf.optionSource': 'Izvor opcija: {value}',
  'set.tf.dependsOnKey': 'Ovisi o: {value}',
  'set.tf.internalLabel': 'Interna oznaka',
  'set.tf.customerLabel': 'Oznaka za klijenta',
  'set.tf.relationshipHelp': 'Određuje odakle se vrijednosti pretraživanja dohvaćaju tijekom izvođenja.',
  'set.tf.validationVisibility': 'Validacija i vidljivost',
  'set.tf.requiredAgents': 'Obavezno za agente',
  'set.tf.requiredCustomers': 'Obavezno za klijente',
  'set.tf.requiredClosure': 'Obavezno za zatvaranje',
  'set.tf.displayedCustomers': 'Prikazano klijentima',
  'set.tf.customersEdit': 'Klijenti mogu uređivati',
  'set.tf.customersFilter': 'Klijenti mogu filtrirati',
  'set.tf.active': 'Aktivno',
  'set.tf.dropdownOptions': 'Opcije padajućeg popisa ({count})',
  'set.tf.archiveTitle': 'Arhivirati „{name}“?',
  'set.tf.archiveDesc': 'Polje će postati neaktivno i nedostupno za nove karte. Postojeći podaci karata se čuvaju.',
  'set.tf.archiveField': 'Arhiviraj polje',
  'set.tf.alreadyArchived': 'Već arhivirano',
  'set.tf.archivedNote': 'Arhivirana polja ostaju dostupna za povijesne vrijednosti.',
  'set.tfm.systemUser': 'Sustav',
  'set.tfm.untitled': 'Obrazac bez naslova',
  'set.tfm.pageDescription': 'Stvorite obrasce za višekratnu uporabu i odaberite koja uvezena polja agenti i klijenti mogu koristiti.',
  'set.tfm.newForm': 'Novi obrazac',
  'set.tfm.creating': 'Stvaranje…',
  'set.tfm.allForms': 'Svi obrasci',
  'set.tfm.configuredOne': '{count} konfiguriran obrazac',
  'set.tfm.configuredMany': 'konfiguriranih obrazaca: {count}',
  'set.tfm.filter': 'Filtar',
  'set.tfm.searchAria': 'Pretraži obrasce zahtjeva',
  'set.tfm.searchPlaceholder': 'Pretraži obrasce…',
  'set.tfm.status': 'Status',
  'set.tfm.allStatuses': 'Svi statusi',
  'set.tfm.emptyFilterTitle': 'Nijedan obrazac ne odgovara ovim filtrima',
  'set.tfm.emptyFilterDesc': 'Pokušajte s drugim izrazom pretraživanja ili proširite filtar statusa.',
  'set.tfm.emptyFirstTitle': 'Stvorite svoj prvi obrazac zahtjeva',
  'set.tfm.emptyFirstDesc': 'Stvorite obrazac za početak konfiguriranja uvezenih polja.',
  'set.tfm.createFirst': 'Stvorite svoj prvi obrazac',
  'set.tfm.colName': 'Naziv',
  'set.tfm.colCreatedAt': 'Stvoreno',
  'set.tfm.colUpdatedBy': 'Zadnje ažurirao/la',
  'set.tfm.colUpdatedAt': 'Zadnje ažurirano',
  'set.tfm.colPortals': 'Povezani portali',
  'set.tfm.colActions': 'Radnje',
  'set.tfm.notConfigured': 'Nije konfigurirano',
  'set.tfm.actionsFor': 'Radnje za {name}',
  'set.tfm.editForm': 'Uredi obrazac',
  'set.tb.section.default.title': 'Zadana polja',
  'set.tb.section.default.desc': 'Osnovna polja tijeka rada podrške uvezena iz izvornog sustava.',
  'set.tb.section.custom.title': 'Prilagođena polja',
  'set.tb.section.custom.desc': 'Dodatna polja konfigurirana za vaš proces podrške.',
  'set.tb.section.nested.title': 'Ugniježđena polja',
  'set.tb.section.nested.desc': 'Ovisna polja čije opcije slijede nadređeno polje.',
  'set.tb.discardTitle': 'Odbaciti nespremljene promjene?',
  'set.tb.discardDesc': 'Vaše izmjene ovog obrasca zahtjeva nisu spremljene.',
  'set.tb.leave': 'Izađi bez spremanja',
  'set.tb.nameRequired': 'Naziv obrasca je obavezan.',
  'set.tb.saved': 'Obrazac je spremljen.',
  'set.tb.nowPublished': 'Obrazac je objavljen.',
  'set.tb.nowUnpublished': 'Objava obrasca je povučena.',
  'set.tb.admin': 'Administrator',
  'set.tb.builder': 'Graditelj',
  'set.tb.titleAria': 'Naslov obrasca',
  'set.tb.defaultLocked': 'Zadano / zaključano',
  'set.tb.previewPortal': 'Pregled na portalu',
  'set.tb.configureTitle': 'Konfigurirajte polja uključena u ovaj obrazac.',
  'set.tb.configureDesc': 'Promjene se trajno spremaju u bazu podataka centra za podršku kada odaberete Spremi promjene. Obavezna polja ostaju uključena.',
  'set.tb.formDetails': 'Detalji obrasca',
  'set.tb.formDetailsHelp': 'Koristite jasan opis kako bi administratori znali kada koristiti ovaj obrazac.',
  'set.tb.descPlaceholder': 'Opišite kada treba koristiti ovaj obrazac…',
  'set.tb.importedFields': 'Uvezena polja',
  'set.tb.importedHelp': 'Povucite za promjenu redoslijeda polja. Koristite prekidač za uključivanje ili isključivanje polja iz ovog obrasca.',
  'set.tb.noneInSection': 'Nema uvezenih polja u ovom odjeljku.',
  'set.tb.dragReorder': 'Povucite za promjenu redoslijeda',
  'set.tb.required': 'Obavezno',
  'set.tb.nested': 'Ugniježđeno',
  'set.tb.enableField': 'Uključi {label}',
  'set.tb.enabled': 'Uključeno',
  'set.tb.disabled': 'Isključeno',
  'set.tb.emptyTitle': 'Još nema polja za konfiguriranje',
  'set.tb.emptyDesc': 'Uvezite polja zahtjeva za početak izrade ovog obrasca.',
  'set.tb.deleting': 'Brisanje…',
  'set.tp.loadError': 'Nije moguće učitati pregled obrasca.',
  'set.tp.preview': 'Pregled',
  'set.tp.customerPreview': 'Pregled za klijente',
  'set.tp.backToBuilder': 'Natrag na graditelj',
  'set.tp.modeTitle': 'Način pregleda',
  'set.tp.modeDesc': 'Ovo je pregled bez slanja. Sva uključena polja prikazana su spremljenim redoslijedom obrasca.',
  'set.tp.emptyTitle': 'Još nijedno polje nije uključeno',
  'set.tp.emptyDesc': 'Uključite polja u graditelju obrazaca da biste ih vidjeli u ovom pregledu.',

  'por.error.generic': 'Nije moguće dovršiti zahtjev.',
  'por.error.requestNotFound': 'Zahtjev nije pronađen.',
  'por.error.formUnavailable': 'Obrazac zahtjeva nije dostupan.',
  'por.error.articleNotFound': 'Članak nije pronađen.',
  'por.error.selectRating': 'Odaberite ocjenu od 1 do 5.',
  'por.tab.all': 'Sve',
  'por.list.title': 'Moji zahtjevi za podršku',
  'por.list.description': 'Pratite svoje zahtjeve i odgovarajte timu za podršku.',
  'por.list.newRequest': 'Novi zahtjev',
  'por.list.knowledgeBase': 'Baza znanja',
  'por.list.filterByStatus': 'Filtriraj zahtjeve po statusu',
  'por.list.searchPlaceholder': 'Pretraži po predmetu…',
  'por.list.count': 'zahtjeva: {count}',
  'por.list.countOne': '{count} zahtjev',
  'por.list.emptyFilteredTitle': 'Nijedan zahtjev ne odgovara ovom prikazu',
  'por.list.emptyTitle': 'Još nema zahtjeva',
  'por.list.emptyFilteredDescription': 'Pokušajte s karticom Sve ili drugim izrazom pretraživanja.',
  'por.list.emptyDescription': 'Pošaljite zahtjev i tim za podršku preuzet će ga.',
  'por.list.submitFirst': 'Pošaljite svoj prvi zahtjev',
  'por.col.request': 'Zahtjev',
  'por.col.subject': 'Predmet',
  'por.col.status': 'Status',
  'por.col.priority': 'Prioritet',
  'por.col.created': 'Stvoreno',
  'por.detail.myRequests': 'Moji zahtjevi',
  'por.detail.reopen': 'Ponovno otvori ovaj zahtjev',
  'por.detail.attachments': 'Privici',
  'por.detail.download': 'Preuzmi',
  'por.detail.conversation': 'Razgovor',
  'por.detail.noReplies': 'Još nema odgovora',
  'por.detail.noRepliesHint': 'Dodajte odgovor ispod i tim za podršku preuzet će ga.',
  'por.detail.reply': 'Odgovor',
  'por.detail.replyPlaceholder': 'Napišite odgovor',
  'por.detail.sending': 'Slanje…',
  'por.detail.sendReply': 'Pošalji odgovor',
  'por.file.sizeKb': '{size} KB',
  'por.file.remove': 'Ukloni {name}',
  'por.submit.newRequest': 'Novi zahtjev',
  'por.submit.defaultTitle': 'Pošaljite zahtjev za podršku',
  'por.submit.intro': 'Ispunite polja ispod i pošaljite svoj zahtjev.',
  'por.submit.subjectRequired': 'Predmet je obavezan',
  'por.submit.descriptionRequired': 'Opis je obavezan',
  'por.submit.attachments': 'Privici',
  'por.submit.submitting': 'Slanje…',
  'por.submit.submit': 'Pošalji zahtjev',
  'por.kb.portal': 'Portal',
  'por.kb.title': 'Baza znanja',
  'por.kb.description': 'Pronađite odgovore prije slanja zahtjeva.',
  'por.kb.crumbRoot': 'KB',
  'por.kb.searchResults': 'Rezultati pretraživanja',
  'por.kb.searchPlaceholder': 'Pretraži članke',
  'por.kb.emptyTitle': 'Još nema objavljenih članaka',
  'por.kb.emptyDescription': 'Pošaljite zahtjev i tim za podršku pomoći će vam izravno.',
  'por.kb.noFolders': 'Nema mapa',
  'por.kb.articles': 'članaka: {count}',
  'por.kb.articlesOne': '{count} članak',
  'por.kb.noMatch': 'Nijedan članak ne odgovara upitu „{query}“',
  'por.kb.folderEmpty': 'U ovoj mapi još nema članaka',
  'por.kb.noMatchHint': 'Pokušajte s kraćim izrazom pretraživanja ili pošaljite zahtjev.',
  'por.kb.folderEmptyHint': 'Pregledajte drugu mapu ili pošaljite zahtjev.',
  'por.kb.submitRequest': 'Pošalji zahtjev',
  'por.kb.views': '{count} pregleda',
  'por.kb.thanks': 'Hvala na povratnim informacijama!',
  'por.kb.helpful': 'Je li ovo bilo korisno?',
  'por.kb.yes': 'Da',
  'por.kb.no': 'Ne',
  'por.csat.thanksTitle': 'Hvala na povratnim informacijama',
  'por.csat.thanksBody': 'Vaš odgovor je zabilježen.',
  'por.csat.title': 'Kako smo prošli?',
  'por.csat.request': 'Zahtjev br. {number}: {subject}',
  'por.csat.rating': 'Ocjena',
  'por.csat.stars': 'zvjezdica: {count}',
  'por.csat.comment': 'Komentar',
  'por.csat.submit': 'Pošalji povratne informacije',
  'agents.tempPassword.title': 'Privremena lozinka',
  'agents.tempPassword.help': 'Postavite privremenu lozinku za ovog agenta. Pri sljedećoj prijavi morat će odabrati novu lozinku. Najmanje 12 znakova.',
  'agents.tempPassword.button': 'Postavi privremenu lozinku',
  'agents.tempPassword.saving': 'Postavljanje…',
  'agents.tempPassword.error': 'Privremenu lozinku nije moguće postaviti.',
  'ui.showPassword': 'Prikaži lozinku',
  'ui.hidePassword': 'Sakrij lozinku',
  'dashboard.awaitingResolutionConfirmation': 'Čeka potvrdu rješenja',
  'dashboard.awaitingUserReply': 'Čeka odgovor korisnika',
  'dashboard.changeRequests': 'Zahtjevi za promjenu',
  'agents.tempPassword.successEmailed': 'Privremena lozinka je postavljena i poslana agentu e-poštom.',
  'agents.tempPassword.successNotEmailed': 'Privremena lozinka je postavljena, ali e-poštu nije bilo moguće poslati. Podijelite lozinku s agentom sigurnim kanalom.',
} as const;

export default hr;
